export const esp = {
  "CONTINUE": "Continuar",
  "SECURE": "Seguro",
  "PRIVATE": "Privado",
  "LOADING_DATA": "Cargando datos",
  "IS REQUIRED": "es requerido",
  "SEARCH": "Buscar",
  "Search": "Buscar",
  "SUBMIT": "Enviar",
  "OK": "OK",
  "No options available": "No hay opciones disponibles",
  "Resource not found.": "Recurso no encontrado.",
  "Internal error.": "Error interno.",
  "Invalid credentials.": "Credenciales inválidas.",
  "ACTIVE": "Activo",
  "INACTIVE": "Inactivo",
  "Inactive": "Inactivo",
  "STARTER": "INICIAL",
  "PLUS": "PLUS",
  "SCALE": "SCALE",
  "PRODUCTION": "PRODUCCIÓN",
  "SANDBOX": "SANDBOX",
  "General": "General",
  "Institutions": "Instituciones",
  "Accounts": "Cuentas",
  "Cash position": "Posición de caja",
  "Transactions": "Transacciones",
  "Transaction": "Transacción",
  "Developers": "Desarrolladores",
  "API Activity": "Actividad de la API",
  "API Keys": "Claves de la API",
  "API Logs": "Registros de la API",
  "Webhooks": "Webhooks",
  "Relevant Links": "Atajos",
  "Widget": "Widget",
  "Guides and docs": "Guías y documentos",
  "My profile": "Mi perfil",
  "Company": "Empresa",
  "Change environment": "Cambiar de entorno",
  "Your financial ecosystem through a single API.":
    "Tu ecosistema financiero a través de una única API.",
  "Welcome": "¡Bienvenido!",
  "back!": "de nuevo!",
  "Business Email": "Email de Negocios",
  "Company domain": "Dominio de la empresa",
  "Password": "Contraseña",
  "Login": "Iniciar sesión",
  "Login to an external account": "Iniciar con cuenta externa",
  "You have an external account enabled":
    "Tienes una cuenta externa habilitada",
  "You have no an external account enabled":
    "No tienes una cuenta externa habilitada",
  "Or": "O",
  "Forgot your password?": "¿Olvidaste tu contraseña?",
  "Don't have an account?": "¿No tienes una cuenta?",
  "Sign up": "Regístrate",
  "© {{year}} Datanomik. All rights reserved.":
    "© {{year}} Datanomik. Todos los derechos reservados.",
  "It's ok, it happens sometimes. Please enter your email address and we'll send you a link to choose a new one.":
    "Está bien, a veces sucede. Ingrese su dirección de correo electrónico y le enviaremos un enlace para elegir una nueva.",
  "Send me a reset link": "Envíame un enlace de reinicio",
  "Enter Verification Code": "Ingrese el código de verificación",
  "Verification": "Verificación",
  "Enter the verification code that has been sent to {{email}}":
    "Ingrese el código de verificacion que ha sido enviado a <strong>{{email}}</strong>",
  "The code sent is valid for 60 minutes.":
    "Éste código tiene una validez de 60 minutos. Algunos usuarios de outlook pueden presentar demoras en recibir el correo de confirmación. Verifique su correo no deseado.",
  "Don't receive the Code?": "¿No recibes el Código?",
  "Verify Code": "Verificar Código",
  "Verify Email": "Verificar Correo",
  "Account successfully verified!": "¡Cuenta verificada con éxito!",
  "Verification code resended!": "¡Código de verificación reenviado!",
  "Resend Code": "Reenviar Código",
  "Resend email": "Reenviar correo",
  "The password must contain at least {{count}} lowercase alphabetical characters.":
    "La contraseña debe contener al menos {{count}} caracteres alfabético en minúsculas.",
  "The password must contain at least {{count}} uppercase alphabetical characters.":
    "La contraseña debe contener al menos {{count}} caracteres alfabético en mayúsculas.",
  "The password must contain at least {{count}} numeric characters.":
    "La contraseña debe contener al menos {{count}} caracteres numéricos.",
  "The password must contain at least {{count}} special characters.":
    "La contraseña debe contener al menos {{count}} caracteres especiales.",
  "The password must be {{count}} characters or longer.":
    "La contraseña debe tener {{count}} caracteres o más.",
  "The password has expired and needs to be updated.":
    "La contraseña ha caducado y es necesario actualizarla.",
  "Please make sure your passwords match.":
    "Por favor, asegúrese de que sus contraseñas coinciden.",
  "URL must start with https://": "La URL debe comenzar con https://",
  "Finance": "Finanzas",
  "FINANCE": "Finanzas",
  "VIEW_FINANCE": "Finanzas",
  "OPERATOR": "Operador",
  "Operations": "Operaciones",
  "Product": "Producto",
  "Other": "Otro",
  "Small business": "Pequeños negocios",
  "Medium business": "Mediana empresa",
  "Large enterprise": "Gran empresa",
  "Financial institution": "Institución financiera",
  "Public sector": "Sector público",
  "Companies": "Compañías",
  "Individuals": "Individuos",
  "Both": "Ambos",
  "Bank / Neobank": "Banco / Neobanco",
  "Contability": "Contabilidad",
  "Financial management": "Gestión financiera",
  "Identity verification": "KYC",
  "Insurance": "Seguro",
  "Investment": "Inversión",
  "Lending": "Crédito",
  "Onboarding": "Onboarding",
  "Payments": "Pagos",
  "Investment Movements": "Movimientos de inversiones",
  "Payment receipt": "Comprobantes de pago",
  "Payments receipt": "Comprobantes de pago",
  "Payments Receipts successfully requested!":
    "Comprobantes de pagos solicitados correctamente!",
  "Payments receipts": "Comprobantes de pagos",
  "Request Payment Receipt": "Solicitar comprobante",
  "Payment Receipt successfully download!":
    "Comprobantes de pago descargado con éxito!",
  "View Requested Payment Receipts list": "Ver lista",
  "{{count}} Requested Payment Receipts": "{{count}} Comprobantes de pagos",
  "Next request": "Siguiente solicitud",
  "Requested Payment Receipts": "Comprobantes de pagos solicitados",
  "downloadableSince": "Descargable desde",
  "Requested at": "Solicitado en",
  "Bulk actions": "Acciones",
  "Unrequest Payment Receipt": "Quitar solicitud de comprobantes",
  "Payments Receipts successfully download!":
    "¡Comprobantes de pagos descargdos correctamente!",
  "Payments Receipts successfully unrequested!":
    "Solicitud de Comprobantes de pagos quitada correctamente!",
  "The selected payments have no receipts generated.":
    "Los pagos seleccionados no poseen comprobantes generados.",
  "Some of the selected payments have no receipts generated and will be omitted.":
    "Algunos de los pagos seleccionados no poseen comprobantes generados y serán omitidos.",
  "The selected payments already have receipts generated.":
    "Los pagos seleccionados ya poseen comprobantes generados.",
  "Some of the selected payments already have receipts generated and will be omitted.":
    "Algunos de los pagos seleccionados ya poseen comprobantes generados y serán omitidos.",
  "The selected payments do not have requested receipts.":
    "Los pagos seleccionados no poseen comprobantes solicitados.",
  "Some of the selected payments do not have requested receipts and will be omitted.":
    "Algunos de los pagos seleccionados no poseen comprobantes solicitados y serán omitidos.",
  "Reconciliation": "Reconciliación",
  "Investment diversification": "Diversificación de las inversiones",
  "Less than 1hs": "Menos de 1h",
  "1 to 6hs": "1 a 6hs",
  "6 to 12hs": "6 a 12hs",
  "More than 12hs": "Más de 12hs",
  "API docs": "Documentos de la API",
  "Contact us": "Contáctanos",
  "Connect your business to the financial ecosystem":
    "Conecta tu negocio al ecosistema financiero",
  "Centralize your cash management and gain a comprehensive financial view.":
    "Centraliza la gestión de tesorería y obtenga una <strong>visión financiera completa.</strong>",
  "Sign up and get a free trial in just a few minutes. Visualize all your bank accounts in a single web platform.":
    "Regístrate y consigue una prueba gratuita en solo unos minutos. Visualiza todas tus cuentas bancarias en una única plataforma web.",
  "Create an account and get a free trial in just a few minutes. No credit card required.":
    "Cree una cuenta y obtenga una prueba gratuita en solo unos minutos. No se requiere tarjeta de crédito.",
  "Start building in our Sandbox environment with sample data.":
    "Comience a construir en nuestro entorno Sandbox con datos de muestra.",
  "Try out our APIs and features without coding a single line:":
    "Pruebe nuestras API y funciones sin codificar una sola línea:",
  "Identity.": "Identidad.",
  "Accounts.": "Cuentas.",
  "Balances.": "Balances.",
  "Transactions.": "Transacciones.",
  "Retrieve real financial information for up to 25 free live links.":
    "Recupere información financiera real para hasta 25 enlaces en vivo gratuitos.",
  "First Name": "Nombre",
  "Last Name": "Apellido",
  "Country": "País",
  "I accept Datanomik's": "Acepto",
  "I accept Datanomiks Terms and Conditions and Privacy Policy.":
    "Acepto los <2>Términos y Condiciones</2> y <6>Políticas de Privacidad</6>.",
  "I agree to the use and processing of my data by Datanomik (Uruguay and Brazil) for commercial purposes and for the improvement of its services.":
    "Acepto el uso y procesamiento de mis datos por Datanomik (Uruguay y Brasil) con fines comerciales y para mejoras de sus servicios.",
  "Terms and Conditions": "Términos y Condiciones",
  "and": "y",
  "Privacy Policy.": "Políticas de Privacidad.",
  "Create my account": "Crear mi cuenta",
  "Company name": "Nombre de la Empresa",
  "Countries of operation": "Países de operación",
  "Country of operation": "País de operación",
  "Mobile": "Móvil",
  "Work area": "Área de trabajo",
  "Company type": "Tipo de Compañía",
  "Your clients are": "Tus clientas son",
  "Use case": "Caso de uso",
  "Number of Institutions": "Número de Instituciones",
  "Refresh rate": "Actualización",
  "New Password": "Nueva contraseña",
  "Repeat New Password": "Repita la nueva contraseña",
  "Repeat Password": "Repita la contraseña",
  "Change Password": "Cambia la contraseña",
  "Help is on the way, please check your email for further instructions.":
    "La ayuda está en camino, consulte su correo electrónico para obtener más instrucciones.",
  "You haven't added a Link yet.": "Aún no ha agregado un Enlace.",
  "Add link": "Agregar Enlace",
  "Actions": "Acciones",
  "Institution": "Institución",
  "Type": "Tipo",
  "Description": "Descripción",
  "description": "Descripción",
  "EXTERNAL_ID": "ID externo",
  "Last update": "Última actualización",
  "Detail": "Detalle",
  "Edit": "Editar",
  "Delete": "Eliminar",
  "Add": "Agregar",
  "Account detail": "Detalle de la cuenta",
  "Investments detail": "Detalle de inversiones",
  "Delete Link": "Eliminar enlace",
  "Confirmation": "Confirmación",
  "Are you sure you want to delete this Link?":
    "¿Estás seguro de que quieres eliminar este Enlace?",
  "Are you sure you want to delete this User?":
    "¿Estás seguro de que quieres eliminar Usuario?",
  "Are you sure you want to delete this Account?":
    "¿Estás seguro que quieres eliminar la cuenta?",
  "Edit Link": "Editar Enlace",
  "Add a Link": "Agregar un Enlace",
  "Links exported successfully!": "Enlaces exportados con éxito!",
  "Transactions exported successfully!": "Transacciones exportadas con éxito!",
  "Link edited successfully!": "Enlace editado con éxito!",
  "Account edited successfully!": "Cuenta editada con éxito!",
  "General Owner edited successfully!":
    "Grupo de Empresas editado con éxito!",
  "Owner edited successfully!": "Empresa editada con éxito!",
  "Account updated successfully!": "Cuenta actualizada con éxito!",
  "Link deleted successfully!": "Enlace eliminado con éxito!",
  "Category group deleted successfully!":
    "Grupo de categoría eliminado con éxito!",
  "Account deleted successfully!": "Cuenta eliminada con éxito!",
  "Bank": "Banco",
  "Link updated successfully!": "Enlace actualizado con éxito!",
  "Link created successfully!": "Enlace creado con éxito!",
  "Select Country": "Seleccione País",
  "Select Institution": "Seleccione Institución",
  "Business": "Negocio",
  "Authentication": "Autenticación",
  "Back": "Atrás",
  "Save": "Guardar",
  "Credentials not configured yet": "Credenciales aún no configuradas",
  "Edit credentials": "Editar credenciales",
  "More fields": "Más campos",
  "Fill in manually": "Completar manualmente",
  "Scan QR code": "Escanear el código QR",
  "Upload QR code": "Cargar el código QR",
  "Manually fill in the digits of the token.":
    "Complete manualmente los dígitos del token",
  "Activate the camera and scan the QR code.":
    "Active la cámara y escanee el código QR.",
  "Upload a file containing the QR code.":
    "Cargue un archivo que contenga el código QR.",
  "Requesting camera permissions...": "Solicitando permisos de cámara...",
  "Scan Qr try again":
    "Verifique que su dispositivo tenga cámara y se encuentre activada<br /><2>Intenta otra vez</2>.",
  "Click here to upload the file with the QR code":
    "Haga clic aqui para cargar el archivo con el QR",
  "Virtual account": "Cuenta virtual",
  "Cancel": "Cancelar",
  "Copied!": "¡Copiado!",
  "Virtual accounts": "Cuentas virtuales",
  "Created at": "Creado en",
  "Accessed at": "Accedido en",
  "Yes": "Sí",
  "No": "No",
  "Name": "Nombre",
  "Email": "Correo electrónico",
  "Address": "Dirección",
  "Account": "Cuenta",
  "Phone": "Teléfono",
  "of": "de",
  "Owner": "Empresa",
  "Owner Name": "Nombre de la Empresa",
  "Type and Number": "Tipo y Número",
  "Status": "Estado",
  "Link status": "Estado",
  "Active": "Activo",
  "Available": "Disponible",
  "SUCCESS": "Disponible",
  "Available Balance": "Saldo disponible",
  "Available balance": "Saldo disponible",
  "Current balance": "Saldo actual",
  "Current Balance": "Saldo actual",
  "Account current balance": "Saldo actual",
  "Investments Gross Value": "Inversiones Valor Bruto",
  "Account available balance": "Saldo disponible",
  "Investments Net Value": "Inversiones Valor Neto",
  "Currency": "Moneda",
  "Filters": "Filtros",
  "Export": "Exportar",
  "Filter": "Filtrar",
  "Clear": "Borrar",
  "Columns": "Columnas",
  "Density": "Densidad",
  "Institution's description": "Descripción de la Institución",
  "active": "activo",
  "inactive": "inactivo",
  "Invalid credentials": "Credenciales incorrectas",
  "Date": "Fecha",
  "Amount": "Monto",
  "Initial amount": "Monto inicial",
  "Initial date": "Fecha inicial",
  "Balance": "Saldo",
  "Reference": "Referencia",
  "reference": "Referencia",
  "Select a Date Range": "Seleccione un rango de fechas",
  "Apply": "Aplicar",
  "Today": "Hoy",
  "Tomorrow": "Mañana",
  "Yesterday": "Ayer",
  "at": "a las",
  "Last 15 minutes": "Últimos 15 minutos",
  "Last 30 minutes": "Últimos 30 minutos",
  "Last 1 hour": "Última hora",
  "Last 4 hours": "Últimas 4 horas",
  "Last 12 hours": "Últimas 12 horas",
  "Last 24 hours": "Últimas 24 horas",
  "Last 48 hours": "Últimas 48 horas",
  "Last 3 days": "Últimos 3 días",
  "Last 5 days": "Últimos 5 días",
  "Last 7 days": "Últimos 7 días",
  "Last 30 days": "Últimos 30 días",
  "Last 1 month": "Último mes",
  "This Month": "Este mes",
  "Last Month": "Mes pasado",
  "This year": "Este año",
  "Last 2 months": "Últimos 2 meses",
  "Last 3 months": "Últimos 3 meses",
  "Last 6 months": "Últimos 6 meses",
  "Last 12 months": "Últimos 12 meses",
  "Next 6 months": "Próximos 6 meses",
  "Next 12 months": "Próximos 12 meses",
  "Last 60 days": "Últimos 60 días",
  "This month": "Este mes",
  "Last year": "Año pasado",
  "Quick filter": "Filtro rápido",
  "Log out": "Cerrar sesión",
  "Generate": "Generar",
  "You haven't generated a webhook yet.": "Aún no has generado un Webhook.",
  "Delete Webhook": "Eliminar Webhook",
  "Are you sure you want to delete this Webhook?":
    "¿Estás seguro de que quieres eliminar este Webhook?",
  "Edit webhook": "Editar Webhook",
  "Generate a webhook": "Generar un Webhook",
  "Webhook deleted successfully!": "¡Webhook eliminado con éxito!",
  "Webhook edited successfully!": "¡Webhook editado con éxito!",
  "Category group edited successfully!":
    "Groupo de categoría editado con éxito!",
  "Webhook created successfully!": "¡Webhook creado con éxito!",
  "Events": "Eventos",
  "Verified": "Verificado",
  "TRANSACTIONS": "Transacciones",
  "transactions": "Transacciones",
  "ACCOUNTS": "Cuentas",
  "accounts": "Cuentas",
  "ACCOUNTS_VERIFICATION": "Verificación de cuentas",
  "accounts_verification": "Verificación de cuentas",
  "You don't have any activity yet": "Aún no tienes actividad",
  "Start building by generating your": "Comienza a construir generando tus",
  "Request Details": "Detalles del Pedido",
  "Response": "Respuesta",
  "Success": "Exitoso",
  "Failure": "Fallido",
  "Method": "Método",
  "Resource": "Recurso",
  "Source": "Fuente",
  "dataSource.BANK": "Realizado calculado automáticamente a partir de las integraciones bancarias",
  "dataSource.FILE": "Datos manuales importados vía archivo",
  "dataSource.API": "Datos importados vía integración con ERP y/o API",
  "ERP": "ERP",
  "IP Address": "Dirección IP",
  "Resources": "Recursos",
  "All Resources": "Todos los Recursos",
  "All Methods": "Todos los Métodos",
  "All Sources": "Todas las Fuentes",
  "All Status": "Todos los Estados",
  "Response code": "Código de Respuesta",
  "All Response Codes": "Todos los Códigos de Respuesta",
  "Balances": "Saldos",
  "balances": "saldos",
  "BALANCES": "SALDOS",
  "owners": "empresas",
  "Owners": "Empresas",
  "label.owners": "Empresas",
  "OWNERS": "EMPRESAS",
  "users": "usuarios",
  "USERS": "USUARIOS",
  "PLATFORM": "Plataforma",
  "Credential successfully created!": "¡Credencial creada con éxito!",
  "Credential successfully saved!": "¡Credencial guardada con éxito!",
  "Credential successfully deleted!": "¡Credencial eliminada con éxito!",
  "Create Date": "Fecha de Creación",
  "Save changes": "Guardar",
  "Generate up to 5 API Keys.": "Genere hasta 5 claves API.",
  "Generate API Keys": "Generar claves API",
  "Start building by generating up to 5 API Keys.":
    "Comience a construir generando hasta 5 claves API.",
  "Are you sure you want to delete this API Key?":
    "¿Está seguro de que desea eliminar esta clave de API?",
  "Delete Key": "Eliminar clave",
  "Before deleting this API Key, we first recommend you to generate a new one and update your applications.":
    "Antes de eliminar esta clave API, primero le recomendamos que genere una nueva y actualice sus aplicaciones.",
  "New credential created": "Nueva credencial creada",
  "We recommend you not to share this information to anyone and also change it from time to time.":
    "Le recomendamos que no comparta esta información con nadie y también la cambie de vez en cuando.",
  "This is the only time the secret password can be viewed. Please copy it and/or download both secrets. If you forgot doing so, you can always create a new API Key.":
    "Esta es la única vez que se puede ver la contraseña secreta. Cópiela y/o descargue ambos secretos. Si olvidó hacerlo, siempre puede crear una nueva clave API",
  "Secret Password": "Contraseña secreta",
  "Secret ID": "ID Secreta",
  "Download CSV": "Descargar CSV",
  "More Filters": "Más Filtros",
  "Contact": "Contacto",
  "Users": "Usuarios",
  "Role": "Rol",
  "Invite a member": "Invitar un miembro",
  "Invite an User": "Invitar un usuario",
  "Disable": "Deshabilitar",
  "Enable": "Habilitar",
  "Send invite": "Enviar invitación",
  "Edit User": "Editar Usuario",
  "bank": "banco",
  "all": "todos",
  "All": "Todos",
  "~ALL~": "Todos",
  "ALL": "TODOS",
  "Enter Password": "Introducir contraseña",
  "User successfully enabled!": "¡Usuario habilitado correctamente!",
  "User successfully disabled!": "¡Usuario deshabilitado exitosamente!",
  "User successfully invited!": "¡Usuario invitado con éxito!",
  "User successfully saved!": "¡Usuario guardado con éxito!",
  "User successfully deleted!": "¡Usuario eliminado con éxito!",
  "Company saved succefully!": "¡Datos de empresa guardados con éxito!",
  "Company updated succefully!": "¡Datos de empresa actualizados con éxito!",
  "Password changed succefully!": "¡Contraseña cambiada con éxito!",
  "Profile saved succefully!": "¡Perfil guardado con éxito!",
  "View Details": "Ver detalles",
  "View details": "Ver detalles",
  "Free": "Gratis",
  "{{freeTrialPeriod}}-days free trial":
    "{{freeTrialPeriod}}-días de prueba gratuita",
  "{{currency}} {{monthlyCost}}/Month": "{{currency}} {{monthlyCost}}/Mes",
  "Including:": "Incluido:",
  "Sandbox environment": "Entorno Sandbox",
  "{{maxPlanIncludedSynCalls}} successful sync calls":
    "{{maxPlanIncludedSynCalls}} llamadas de sincronización exitosas",
  "Standard customer service": "Servicio de atención al cliente estándar",
  "Dedicated account manager": "Administrador de cuentas dedicado",
  "For additional calls, pay as you go {{currency}} {{exceededPlanSynCallCost}}0 per successful sync call.":
    "Para llamadas adicionales, pague sobre la marcha {{currency}} {{exceededPlanSynCallCost}}0 por llamada de sincronización exitosa.",
  "Plans": "Planes",
  "Subscription": "Suscripción",
  "Most Popular!": "¡Más popular!",
  "Subscription end date": "Fecha de finalización de la suscripción",
  "Your subcription will be automatically renewed each month":
    "Su suscripción se renovará automáticamente cada mes.",
  "Available Plans": "Planes disponibles",
  "Plus": "Plus",
  "Upgrade Now": "Actualizar ahora",
  "Upgrade now": "Actualizar ahora",
  "Scale": "Scale",
  "Get a custom plan and dedicated support!":
    "¡Obtenga un plan personalizado y soporte dedicado!",
  "Contact Sales": "Contactar con Ventas",
  "Card number": "Número de tarjeta",
  "Document name": "Nombre del documento",
  "Document number": "Número del Documento",
  "Scale Plan": "Plan Scale",
  "Upgrade Confirmation": "Confirmación de actualización",
  "Successful upgrade": "Actualización exitosa",
  "Thanks for contacting us, we will contact you as soon as possible":
    "Gracias por contactar con nosotros, nos pondremos en contacto contigo lo antes posible.",
  "Starter": "Inicial",
  "Active Plan": "Plan Activo",
  "Pending Plan": "Plan Pendiente",
  "Expired Plan": "Plan Expirado",
  "Days": "Días",
  "{{cantDays}} of {{totalDays}}": "{{cantDays}} de {{totalDays}}",
  "{{daysRemaining}} days remaining": "{{daysRemaining}} días restantes",
  "We'll contact you to build up the right plan for your business, including:":
    "Nos pondremos en contacto con usted para crear el plan adecuado para su negocio, que incluye:",
  "More refresh frequency!": "¡Más frecuencia de actualización!",
  "Select a company type": "Seleccione un tipo de empresa",
  "Select a frequency interval": "Seleccione un intervalo de frecuencia",
  "Refresh Frequency": "Frecuencia de actualización",
  "Select a use case scenario": "Seleccione un escenario de caso de uso",
  "Elaborate on why you need these specific things...":
    "Explique por qué necesita estas cosas específicas...",
  "Tell us more about your specific needs":
    "Cuéntanos más sobre tus necesidades específicas",
  "Purchase summary": "Resumen de compra",
  "Purchase": "Compra",
  "Proceed to checkout": "Proceder a verificar",
  "Cardholder name": "Nombre del titular de la tarjeta",
  "Card Number": "Número de tarjeta",
  "Expiration Date": "Fecha de caducidad",
  "Pay": "Pagar",
  "Continue": "Continuar",
  "Save and continue": "Guardar y continuar",
  "API Calls": "Llamadas a la API",
  "API call evolution": "Evolución de las llamadas a la API",
  "Success calls": "Llamadas exitosas",
  "Failed calls": "Llamadas fallidas",
  "Total calls": "Llamadas totales",
  "Session expired": "Sesión expirada",
  "Unauthorized": "No autorizado",
  "Monthly": "Mensual",
  "Success Rate": "Tasa de éxito",
  "Failed": "Fallido",
  "Recurrent": "Recurrente",
  "One-shot": "One-shot",
  "Compact": "Compacto",
  "Standard": "Estándar",
  "Comfortable": "Cómodo",
  "Find column": "Buscar columna",
  "Column title": "Título de la columna",
  "Reorder column": "Reordenar columna",
  "Show all": "Mostrar todo",
  "Hide all": "Ocultar todo",
  "assets": "assets",
  "Assets": "Assets",
  "ASSETS": "ASSETS",
  "LINKS": "Enlaces",
  "Upgrade your plan for more links and data synchronizations.":
    "Actualice su plan para obtener más links y sincronizaciones de datos.",
  "Recurrent Links": "Links recurrentes",
  "Total Links": "Links totales",
  "Up to {{maxRecurrentLink}} recurrent link/s with {{refreshFrequency}}hs refresh frequency":
    "Hasta {{maxRecurrentLink}} link/s recurrente/s con {{refreshFrequency}}hs frecuencia de actualización",
  "Unlimited test links": "Links de prueba ilimitados",
  "Links": "Enlaces",
  "links": "Enlaces",
  "Live": "Live",
  "C-Level": "C-Level",
  "Live demo": "Demo en Vivo",
  "TI": "Desarrollador",
  "Extra recurrent links": "Links recurrentes extra",
  "Number of one-shot links per month": "Número de links one-shot por mes",
  "Number of recurrent links per month": "Número de links recurrentes por mes",
  "Recurrent Links/Month": "Links recurrentes/mes",
  "Total Current Balance": "Saldo Actual Total",
  "First name": "Nombre",
  "Last name": "Apellido",
  "Second last name": "Segundo apellido",
  "Change credentials": "Cambiar credenciales",
  "Upgrade plan now": "Actualice su plan ahora",
  "Your subscription has expired on {{validUntil}}.":
    "Su suscripción caducó el {{validUntil}}.",
  "Your subscription will expire on {{validUntil}}.":
    "Su suscripción caducará el {{validUntil}}.",
  "Until {{validUntil}}": "Hasta {{validUntil}}",
  "Access denied": "Acceso denegado",
  "7 days": "7 días",
  "15 days": "15 días",
  "30 days": "30 días",
  "Current month": "Mes actual",
  "No options": "Sin opciones",
  "Loading": "Cargando...",
  "Basic Information": "Información básica",
  "Next": "Siguiente",
  "Submit": "Enviar",
  "Write at least 3 characters to start searching":
    "Escribe al menos 3 caracteres para empezar a buscar",
  "We were unable to link the Institution":
    "No pudimos vincular la Institución",
  "Please verify the information filled in and try again.":
    "Verifique la información completada y vuelva a intentarlo.",
  "Try again": "Intentar otra vez",
  "Validating credentials": "Validando sus credenciales",
  "We're almost done! This can take a few seconds.":
    "¡Ya casi terminamos! Esto puede demorar unos segundos.",
  "Please don't close this window.": "Por favor no cierre esta ventana.",
  "We are processing the transactions. This can take a few seconds.":
    "Estamos procesando las transacciones. Esto puede demorar unos segundos.",
  "The Institution was successfully linked":
    "La Institución se vinculó exitosamente",
  "Profile": "Perfil",
  "Supports Widget Recurrent Link": "Admite Link Recurrente en el Widget",
  "No rows found.": "No se encontraron filas.",
  "No rows": "Sin filas",
  "No results found.": "No se han encontrado resultados.",
  "An error occurred.": "Ocurrió un error.",
  "No occurrences": "Sin ocurrencias",
  "occurrences": "ocurrencias",
  "General account status": "Estado general de las cuentas",
  "Sender": "Remitente",
  "SENDER": "Remitente",
  "SENDER_DOCUMENT": "Documento del Remitente",
  "Sender detail": "Detalles del Remitente",
  "senderName": "Remitente",
  "Beneficiary": "Beneficiario",
  "BENEFICIARY": "Beneficiario",
  "BENEFICIARY_DOCUMENT": "Documento del Beneficiario",
  "Beneficiary detail": "Detalles del Beneficiario",
  "beneficiaryName": "Beneficiario",
  "PI_TYPE": "Institución de pago",
  "BANK_TYPE": "Institución Bancaria",
  "OF_TYPE": "Open Finance",
  "Payment method": "Método de pago",
  "Please confirm us the following information":
    "Por favor confirmanos la siguiente información",
  "Growth Plan": "Growth Plan",
  "Custom Plan": "Custom Plan",
  "Get a tailored plan for your business":
    "Obtenga un plan a la medida para su negocio",
  "Grow your business with our pay-as-you-go plan":
    "Haga crecer su negocio y pague solamente por lo que usa",
  "The first {{freeTrialPeriod}} days are on us!":
    "¡Los primeros {{freeTrialPeriod}} días son por nuestra cuenta!",
  "More data synchronization / month": "Más sincronización de datos / mes",
  "More refresh frequency": "Más frecuencia de actualización",
  "No contractual minimums": "Sin mínimos contractuales",
  "Up to {{total}} data synchronizations / month":
    "Hasta {{total}} sincronizaciones de datos / mes",
  "{{currency}} {{cost}} per synchronization":
    "{{currency}} {{cost}} por sincronización",
  "{{refreshRate}} hs refresh rate":
    "{{refreshRate}} hs de frecuencia de actualización",
  "Requested Plan": "Plan solicitado",
  "Subscribe": "Suscribir",
  "Your tailored plan includes:": "Tu plan personalizado incluye:",
  "Blocked account": "Cuenta bloqueada",
  "Visualize your company's financial data in a single web platform.":
    "Visualiza los datos financieros de tu empresa en una única plataforma web.",
  "Other Plans": "Otros Planes",
  "Add Payment Method": "Agregar Método de Pago",
  "Edit Payment Method": "Editar Método de Pago",
  "Please select your Payment Method.":
    "Por favor seleccione su Método de Pago.",
  "The free trial ends on {{validUntil}}.":
    "El período de prueba finaliza el {{validUntil}}.",
  "Admin": "Administrador",
  "ADMIN": "Administrador",
  "GENERAL_ADMINISTRATOR": "Administrador General",
  "Developer": "Desarrollador",
  "DEVELOPER": "Desarrollador",
  "Read only": "Solo lectura",
  "The information was successfully updated!":
    "¡La información fue actualizada satisfactoriamente!",
  "Refresh": "Actualizar",
  "Retrieve Accounts": "Recuperar Cuentas",
  "Recovered accounts with success!": "¡Cuentas recuperadas con éxito!",
  "READ_ONLY": "Solo lectura",
  "Welcome back to Business Gate": "Bienvenido a <strong>Datanomik</strong>",
  "Visualize your financial data in a single web platform.":
    "Visualiza todas tus cuentas bancarias en una única plataforma web.",
  "Understand your company's cash flow and make strategic decisions with Datanomik's Smart Treasury":
    "Comprenda el flujo de caja de su empresa y tome decisiones estratégicas con la <4>Tesorería Inteligente</4> de <2>Datanomik</2>",
  "Have an account?": "¿Tienes una cuenta?",
  "Need a help?": "¿Necesitas ayuda?",
  "Talk with us": "Habla con nosotros",
  "Sign in": "Iniciar",
  "Create your account": "Crea tu cuenta",
  "Log in to your account": "Ingrese a su cuenta",
  "Welcome back {{firstName}}!": "¡Bienvenido de nuevo {{firstName}}!",
  "Check out your financial overview": "Consulte su posición financiera",
  "than last day": "que el día anterior",
  "Last update: {{lastUpdate}}": "Última actualización: {{lastUpdate}}",
  "Without activity": "Sin actividad",
  "Current Balance / Institution": "Saldo Actual / Institución",
  "Current Balance / Owner": "Saldo Actual / Empresa",
  "Current Balance / Country": "Saldo Actual / País",
  "Current Balance / Owner Tag": "Saldo Actual / Etiqueta de la empresa",
  "Current Balance / Account Tag": "Saldo Actual / Etiqueta de cuenta",
  "Current Balance / Account group": "Saldo Actual / Grupo de cuenta",
  "Without data": "Sin datos",
  "Overview": "Visión general",
  "Debits": "Débitos",
  "in Debits": "en Débitos",
  "Credits": "Créditos",
  "in Credits": "en Créditos",
  "Date Range": "Rango de fechas",
  "Inflows, outflows and balance evolution":
    "Evolución de créditos, débitos y saldo",
  "Balance evolution": "Evolución de saldo",
  "Inflows and Outflows": "Créditos y Débitos",
  "Show balance": "Mostrar saldo",
  "Show projected": "Mostrar proyectado",
  "Hide empty categories": "Ocultar categorías vacías",
  "Showing only with values": "Mostrando solo con valores",
  "Showing all categories": "Mostrando todas las categorías",
  "Period too long for daily view": "Período demasiado largo para vista diaria",
  "For better visualization, we recommend using Weekly or Monthly grouping":
    "Para una mejor visualización, recomendamos usar agrupación Semanal o Mensual",
  "Inflow per Institution": "Crédito por Institución",
  "Outflow per Institution": "Débito por Institución",
  "Net per Institution": "Neto por Institución",
  "Net": "Neto",
  "Net position per Institution": "Posición neta por Institución",
  "Net position": "Posición neta",
  "Total Net position": "Posición neta",
  "REQUESTED": "Solicitado",
  "Requested": "Solicitado",
  "IN_PROGRESS": "En progreso",
  "PROCESSED": "Procesado",
  "Processed": "Procesado",
  "Settings": "Ajustes",
  "Link description": "Descripción del enlace",
  "Link": "Enlace",
  "Verify": "Verificar",
  "From": "De",
  "To": "A",
  "Card": "Tarjeta",
  "CREDIT": "Tarjeta",
  "Bank Transfer": "Transferencia bancaria",
  "TRANSFER": "Transferencia bancaria",
  "You are in test mode.": "Estas en ambiente de prueba.",
  "Please do not enter real bank credentials.":
    "Por favor, no ingrese credenciales bancarias reales.",
  "Yes, continue": "Sí, continuar",
  "No, go to production": "No, ir a producción",
  "BANK": "Banco",
  "Language of preference": "Idioma de preferencia",
  "PI": "Institución de pago",
  "Pi": "Institución de pago",
  "pi": "Institución de pago",
  "OF": "Open Finance",
  "Inflow": "Créditos",
  "Outflow": "Débitos",
  "INFLOW": "Créditos",
  "OUTFLOW": "Débitos",
  "Welcome to Business Gate": "Bienvenido al Business Gate",
  "Set up your dashboard in 3 single steps and centralize your company's financial data in real-time.":
    "Configura tu dashboard en tan solo 3 pasos y centraliza la información financiera de tu empresa en tiempo real.",
  "Connect my institutions": "Conectar mis instituciones",
  "or try with test data": "o usarlo con datos de prueba",
  "Refresh rate (mins)": "Frecuencia de actualización (mins)",
  "The minimum refresh rate is {{min}} minutes":
    "La frecuencia de actualización mínima es {{min}} minutos",
  "or try with test data on Sandbox environment":
    "o usarlo con datos de prueba en el ambiente Sandbox",
  "FIXED_DEPOSIT": "Plazo fijo",
  "Fixed deposit": "Plazo fijo",
  "fixed deposit": "Plazo fijo",
  "Expand": "Expandir",
  "Collapse": "Colapsar",
  "Related links": "Enlaces relacionados",
  "Related users": "Usuarios relacionados",
  "Virtual links": "Enlaces virtuales",
  "Add new virtual link": "Agregar un nuevo enlace virtual",
  "Edit virtual link": "Editar enlace virtual",
  "Delete Virtual link": "Eliminar enlace virtual",
  "Are you sure you want to delete this Virtual link?":
    "¿Estás seguro de que quieres eliminar este enlace virtual?",
  "Virtual link successfully deleted!": "¡Enlace virtual eliminado con éxito!",
  "Virtual link successfully!": "¡Enlace virtual creado con éxito!",
  "Virtual link successfully saved!": "¡Enlace virtual guardado con éxito!",
  "COUNT_SELECTED_zero": "0 seleccionado",
  "COUNT_SELECTED_one": "1 seleccionado",
  "COUNT_SELECTED_other": "{{count}} seleccionados",
  "Available Links": "Enlaces disponibles",
  "Selected Links": "Enlaces seleccionados",
  "Available Users": "Usuarios disponibles",
  "Selected Users": "Usuarios seleccionados",
  "No Data": "Sin datos",
  "Assign links": "Asignar enlaces",
  "Assign users": "Asignar usuarios",
  "{{x}} account/s with negative balance": "{{x}} cuenta/s con saldo negativo",
  "Reset link sent!": "¡Enlace de reinicio enviado!",
  "Authentication Type": "Tipo de Autenticación",
  "ACCOUNT": "Cuenta",
  "BALANCE": "Saldo",
  "Current account balance": "Saldo",
  "AMOUNT": "Monto",
  "EQUALS": "Igual",
  "TRANSACTION": "Transacción",
  "PAYMENT": "Pago",
  "PAYMENTS": "Pagos",
  "INVESTMENT_MOVEMENTS": "Movimientos de inversiones",
  "PAYMENT_RECEIPT": "Comprobantes de pago",
  "PIX_TRANSACTION": "Pix",
  "PERIOD_STATEMENT": "Extracto por período",
  "MONTHLY": "Mensual",
  "DESCRIPTION": "Descripción",
  "CONTAINS": "Contiene",
  "NOT_CONTAINS": "No contiene",
  "STARTS_WITH": "Comienza con",
  "ENDS_WITH": "Termina con",
  "GREATER_THAN": "Mayor que",
  "LESS_THAN": "Menor que",
  "BETWEEN": "Entre",
  "REFERENCE": "Referencia",
  "Variable": "Variable",
  "Attribute": "Atributo",
  "Condition": "Condición",
  "Value": "Valor",
  "Channel": "Canal",
  "Channels": "Canales",
  "View Rule": "Ver regla",
  "Are you sure you want to delete this Rule?":
    "¿Está seguro de que desea eliminar esta regla?",
  "Add new Rule": "Agregar nueva regla",
  "EMAIL": "Email",
  "STATUS": "Estado",
  "Notifications": "Notificaciones",
  "Roles reference": "Referencia de roles",
  "can access every module of the platform with all the permissions.":
    "puede acceder a todos los módulos de la plataforma con todos los permisos.",
  "has access to the financial modules of the platform. Can add, edit, refresh and delete links.":
    "tiene acceso a los módulos financieros de la plataforma. Puede agregar, editar, actualizar y eliminar links.",
  "has access only to the technical modules of the platform.":
    "tiene acceso únicamente a los módulos técnicos de la plataforma.",
  "similar to the Finance role, but can't add links.":
    "similar al rol de Finanzas, pero no puede agregar links.",
  "en": "Inglés",
  "es": "Español",
  "pt": "Portugués",
  "Rule created successfully!": "¡Regla creada con éxito!",
  "Rule deleted successfully!": "¡Regla eliminada con éxito!",
  "Rule updated successfully!": "¡Regla actualizada con éxito!",
  "Edit Rule": "Editar Regla",
  "linkId": "Descripción del enlace",
  "institutionId": "Institución",
  "institutionName": "Institución",
  "ownerId": "Empresa",
  "generalOwnerId": "Empresa",
  "type": "Tipo",
  "availableBalanceLte": "Saldo disponible <=",
  "availableBalanceGte": "Saldo disponible >=",
  "currentBalanceGte": "Saldo actual >=",
  "currentBalanceLte": "Saldo actual <=",
  "availablePositionLte": "Posición disponible <=",
  "availablePositionGte": "Posición disponible >=",
  "currentPositionGte": "Posición actual >=",
  "currentPositionLte": "Posición actual <=",
  "accountId": "Cuenta",
  "currency": "Moneda",
  "dateFrom": "Desde",
  "dateFromHistory": "Desde",
  "dateTo": "Hasta",
  "dateToHistory": "Hasta",
  "trxType": "Tipo",
  "amountTo": "Monto <=",
  "amountFrom": "Monto >=",
  "feeTo": "Comisión <=",
  "feeFrom": "Comisión >=",
  "source": "Fuente",
  "module": "Recursos",
  "httpMethod": "Método",
  "responseStatus": "Estado",
  "httpResponseStatus": "Código de Respuesta",
  "Point of Contact": "Punto de contacto",
  "Severity": "Prioridad",
  "Lowest": "Muy baja",
  "Low": "Baja",
  "Medium": "Media",
  "High": "Alta",
  "Highest": "Muy alta",
  "Your credentials are securely encrypted":
    "Sus credenciales están encriptadas de forma segura",
  "Institution successfully linked!": "¡Institución vinculada con éxito!",
  "We're processing transactions, this might take a while to reflect on the dashboard.":
    "Estamos procesando transacciones, esto puede tardar un tiempo en reflejarse en el dashboard.",
  "To read the full list please view the account detail":
    "Para leer la lista completa, consulte los detalles de la cuenta",
  "For a refresh rate under {{frequency}} min, please contact our sales team.":
    "Para una frecuencia menor a {{frequency}} min, contactese con nuestro equipo comercial.",
  "You have {{x}} new message/s!": "¡Tiene {{x}} mensajes nuevos!",
  "Mark all as read": "Marcar todo como leído",
  "Only show unread": "Mostrar solo no leídos",
  "History": "Historial",
  "View detail": "Ver detalle",
  "Mark as unread": "Marcar como no leído",
  "Mark as read": "Marcar como leído",
  "Close": "Cerrar",
  "Credentials": "Credenciales",
  "Connect": "Conectar",
  "Step {{x}}": "Paso {{x}}",
  "See all notifications": "Ver todas las notificaciones",
  "Identification": "Identificación",
  "Rules": "Reglas",
  "name": "Nombre",
  "value": "Valor",
  "email": "Correo electrónico",
  "resource": "Variable",
  "Module": "Módulo",
  "field": "Atributo",
  "constraint": "Condición",
  "severity": "Prioridad",
  "Billing history": "Facturación",
  "Period": "Período",
  "Plan": "Plan",
  "Synchronizations": "Sincronizaciones",
  "Price (USD)": "Precio (USD)",
  "Amount (USD)": "Monto (USD)",
  "The account <strong>{{accountNumber}}</strong> has been blocked by the Institution.":
    "La cuenta <strong>{{accountNumber}}</strong> ha sido bloqueada por la institución.",
  "The account <strong>{{accountNumber}}</strong> has a balance equal to {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> tiene un saldo igual a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> has a balance higher than {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> tiene un saldo mayor a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> has a balance lower than {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> tiene un saldo menor a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> has a balance between {{constraintValue.constraintValueFrom}} and {{constraintValue.constraintValueTo}}.":
    "La cuenta <strong>{{accountNumber}}</strong> tiene un saldo entre {{constraintValue.constraintValueFrom}} y {{constraintValue.constraintValueTo}}.",
  "The account <strong>{{accountNumber}}</strong> has a judicial blocked balance higher than {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> tiene un saldo bloqueado judicialmente mayor a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with an amount equal to {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un monto igual a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with an amount higher than {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un monto mayor a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with an amount lower than {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un monto menor a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with an amount between {{constraintValue.constraintValueFrom}} and {{constraintValue.constraintValueTo}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un monto entre {{constraintValue.constraintValueFrom}} y {{constraintValue.constraintValueTo}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a fee equal to {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con una comisión igual a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a fee higher than {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con una comisión mayor a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a fee lower than {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con una comisión menor a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a fee between {{constraintValue.constraintValueFrom}} and {{constraintValue.constraintValueTo}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con una comisión entre {{constraintValue.constraintValueFrom}} y {{constraintValue.constraintValueTo}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a reference equal to {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con una referencia igual a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a reference that contains {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con una referencia que contiene {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a reference that not contains {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con una referencia que no contiene {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a reference that starts with {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con una referencia que empieza con {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a reference that ends with {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con una referencia que termina con {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with an external ID equal to {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un ID externo igual a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with an external ID that contains {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un ID externo que contiene {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with an external ID that not contains {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un ID externo que no contiene {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with an external ID that starts with {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un ID externo que empieza con {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with an external ID that ends with {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un ID externo que termina con {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a description equal to {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con una descripción igual a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a description that contains {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con una descripción que contiene {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a description that not contains {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con una descripción que no contiene {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a description that starts with {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con una descripción que empieza con {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a description that ends with {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con una descripción que termina con {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a category equal to {{constraintValue}}.":
    "La cuenta <strong> {{accountNumber}}</strong> registró una transacción con una categoría igual a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender equal to {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un remitente igual a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender that contains {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un remitente que contiene {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender that not contains {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un remitente que no contiene {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender that starts with {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un remitente que empieza con {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender that ends with {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un remitente que termina con {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary equal to {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un beneficiario igual a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary that contains {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un beneficiario que contiene {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary that not contains {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un beneficiario que no contiene {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary that starts with {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un beneficiario que empieza con {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary that ends with {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un beneficiario que termina con {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender's document equal to {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un documento de remitente igual a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender's document that contains {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un documento de remitente que contiene {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender's document that not contains {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un documento de remitente que no contiene {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender's document that starts with {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un documento de remitente que empieza con {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a sender's document that ends with {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un documento de remitente que termina con {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary's document equal to {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un documento de beneficiario igual a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary's document that contains {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un documento de beneficiario que contiene {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary's document that not contains {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un documento de beneficiario que no contiene {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary's document that starts with {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un documento de beneficiario que empieza con {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary's document that ends with {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró una transacción con un documento de beneficiario que termina con {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with an amount equal to {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró un pago con un monto igual a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with an amount higher than {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró un pago con un monto mayor a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with an amount lower than {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró un pago con un monto menor a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with an amount between {{constraintValue.constraintValueFrom}} and {{constraintValue.constraintValueTo}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró un pago con un monto entre {{constraintValue.constraintValueFrom}} y {{constraintValue.constraintValueTo}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with a reference equal to {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró un pago con una referencia igual a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with a reference that contains {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró un pago con una referencia que contiene {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with a description equal to {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró un pago con una descripción igual a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with a description that contains {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró un pago con una descripción que contiene {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with a category equal to {{constraintValue}}.":
    "La cuenta <strong> {{accountNumber}}</strong> registró un pago con una categoría igual a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with a beneficiary equal to {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró un pago con un beneficiario igual a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with a beneficiary that contains {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró un pago con un beneficiario que contiene {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with a beneficiary's document equal to {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró un pago con un documento de beneficiario igual a {{constraintValue}}.",
  "The account <strong>{{accountNumber}}</strong> registered a payment with a beneficiary's document that contains {{constraintValue}}.":
    "La cuenta <strong>{{accountNumber}}</strong> registró un pago con un documento de beneficiario que contiene {{constraintValue}}.",
  "Approved": "Aprobada",
  "Expired": "Expirada",
  "Created": "Creada",
  "Blocked": "Bloqueada",
  "User blocked": "Bloqueado",
  "Refused": "Rechazada",
  "Pending": "Pendiente",
  "APPROVED": "Aprobada",
  "EXPIRED": "Expirada",
  "CREATED": "Creada",
  "BLOCKED": "Bloqueada",
  "REFUSED": "Rechazada",
  "PENDING": "Pendiente",
  "Billing information": "Datos de facturación",
  "Please complete the billing information":
    "Primero complete los datos de facturación",
  "Fiscal Number": "Número fiscal",
  "Billing information successfully saved!":
    "¡Datos de facturación guardados con éxito!",
  "Edit Billing information": "Editar datos de facturación",
  "Never": "Nunca",
  "Conditions": "Condiciones",
  "Finalize": "Finalizar",
  "Time from": "Hora desde",
  "Time to": "Hora hasta",
  "When condition is met": "Cuando se cumple la condición",
  "Assign accounts": "Asignar cuentas",
  "Available accounts": "Cuentas disponibles",
  "Selected accounts": "Cuentas seleccionadas",
  "Expand all": "Expandir todo",
  "Collapse all": "Colapsar todo",
  "Show only categories with values": "Mostrar solo categorias con valores",
  "Show all categories": "Mostrar todas las categorias",
  "Table": "Tabla",
  "Chart": "Gráfico",
  "Charts": "Gráficos",
  "Click on the chart to explore details": "Haga clic en el gráfico para explorar detalles",
  "Top": "Arriba",
  "Bottom": "Abajo",
  "Tabbed": "Pestañas",
  "transactionId": "ID de transacción",
  "STAGE_ALPHA": "Alfa",
  "STAGE_BETA": "Beta",
  "STAGE_STABLE": "Estable",
  "Main currency": "Moneda principal",
  "Set main currency": "Establecer moneda principal",
  "Collapse menu": "Contraer menú",
  "Expand menu": "Expandir menú",
  "virtualLinkId": "Enlace virtual",
  "limitDate": "Fecha límite",
  "Limit date": "Fecha límite",
  "There is no active plan in order to be able to establish a new link.":
    "No existe ningún plan activo para poder establecer un nuevo link.",
  "It appears you don't have permissions to access this page":
    "Parece que no tienes permisos para acceder a esta página",
  "Back to home page": "Volver a la página de inicio",
  "Invalid username or password": "Usuario o contraseña inválidos",
  "Request": "Solicitar",
  "Request history": "Solicitar histórico",
  "Date range": "Rango de fechas",
  "{{institution}} allows consulting historic information up to {{maxRecoveryMonth}} months.":
    "{{institution}} permite consultar información histórica hasta {{maxRecoveryMonth}} meses.",
  "Select a date range": "Seleccione un rango de fechas",
  "transactionStatus": "Estado de la transacción",
  "Processing": "Procesando",
  "Processing Accounts": "Procesando Cuentas",
  "Processing Transactions": "Procesando Transacciones",
  "We are still processing transactions for some Links.":
    "Estamos procesando transacciones de algunos Links.",
  "Company details": "Detalles de la compañía",
  "Point of contact": "Punto de contacto",
  "Check Rates": "Ver tasas",
  "Currency rates": "Tipos de cambio",
  "Historic rates": "Tasas históricas",
  "We are still processing the accounts and balances.":
    "Estamos procesando las cuentas y balances.",
  "We are still processing the accounts and balances for some Links.":
    "Estamos procesando las cuentas y balances de algunos Links.",
  "We're processing the information, this might take a while to reflect on the dashboard.":
    "Estamos procesando la información, esto puede tardar un tiempo en reflejarse en el panel.",
  "Let’s get you started with Datanomik, please take a look at the following steps.":
    "Para comenzar a operar con Datanomik, por favor siga los siguientes pasos.",
  "Creating a link": "Crear un link",
  "Three steps are required to create a new link: select country, select institution, and login.":
    "Cree un link en tan solo 3 pasos: seleccione un país, seleccione una institución y haga login",
  "Create link": "Crear link",
  "...or test with fake data": "...u opere con datos de prueba",
  "User": "Usuario",
  "Invite your team to Business Gate and assign roles. They will be able to set up their own accounts.":
    "Invita otros miembros y asigna roles. Luego podrán configurar sus propias cuentas.",
  "Invite user": "Invitar usuario",
  "Invite new user": "Invitar nuevo usuario",
  "Connect our APIs": "Conecta nuestras APIs",
  "Developer roles": "Rol desarrollador",
  "Create a developer profile within Business Gate to integrate our APIs.":
    "Invita desarrolladores para integrar nuestras APIs.",
  "Create a developer profile": "Invitar desarrolladores",
  "Generate up to 5 API Keys and test with sample and real data through a sandbox environment.":
    "Genera hasta 5 API Keys y comenza a probar con datos reales y de prueba en nuestro entorno Sandbox.",
  "Integrate APIs": "Integra las APIs",
  "Forget lengthy and costly integrations. Set up Datanomik’s APIs with just a few lines of code.":
    "Olvida las integraciones largas y costosas. Las APIs de Datanomik son las más adaptables y seguras en el mercado.",
  "Read API docs": "Ver API docs",
  "CURRENT_BALANCE_ACCOUNT_TAG_INFO_TEXT":
    "Este gráfico presenta cómo se distribuyen sus saldos en cada moneda por etiqueta de cuenta.",
  "CURRENT_BALANCE_ACCOUNT_GROUP_INFO_TEXT":
    "Este gráfico presenta cómo se distribuyen sus saldos en cada moneda por grupo de cuenta.",
  "CURRENT_BALANCE_GENERAL_OWNER_TAG_INFO_TEXT":
    "Este gráfico presenta cómo se distribuyen sus saldos en cada moneda por etiqueta de la empresa.",
  "CURRENT_BALANCE_INSTITUTION_INFO_TEXT":
    "Este gráfico presenta cómo se distribuyen sus saldos en cada moneda por institución.",
  "CURRENT_BALANCE_GENERAL_OWNER_INFO_TEXT":
    "Este gráfico presenta cómo se distribuyen sus saldos en cada moneda por empresa.",
  "CURRENT_BALANCE_COUNTRY_INFO_TEXT":
    "Este gráfico presenta cómo se distribuyen sus saldos en cada moneda por país.",
  "NET_POSITION_PER_INSTITUTION_INFO_TEXT":
    "Este gráfico presenta la suma de créditos y débitos por institución, y la posición neta resultante. Puede aplicar filtros.",
  "CREDITS_DEBITS_AND_BALANCE_EVOLUTION_INFO_TEXT":
    "Este gráfico presenta cómo evolucionan los saldos, los créditos y los débitos a lo largo del tiempo. Puede aplicar filtros.",
  "BALANCE_EVOLUTION_INFO_TEXT":
    "Este gráfico presenta cómo evolucionan los saldos a lo largo del tiempo. Puede aplicar filtros.",
  "LINK_DESCRIPTION_FIELD_INFO_TEXT":
    "Configure una descripción para esta institución. Podrás usarla luego para filtrar o buscar información fácilmente.",
  "TOTAL_CURRENT_BALANCE_INFO_TEXT":
    "Esta sección presenta la suma de los saldos actuales en cada moneda de todos los enlaces. Verifique las ultimas actualizaciones.",
  "I’m not sure which credentials I should use...":
    "No estoy seguro de qué credenciales debo usar...",
  "We use the highest security standards to protect all information end-to-end":
    "Usamos los más altos estándares de seguridad para proteger la información punta a punta",
  "LINK_MODAL_INFO_TEXT":
    "Se le solicitará que configure credenciales para acceder a cada institución. Recomendamos crear un usuario dedicado para el uso exclusivo de <strong>Business Gate</strong>.",
  "LINK_MODAL_CREDENTIALS_INFO_TEXT":
    "Para vincular su cuenta, complete los campos con las mismas credenciales que utiliza para acceder a su banco.",
  "Go Back": "Volver",
  "Invalid Email": "Email inválido",
  "Default Virtual link": "Enlace virtual predeterminado",
  "VIRTUAL_LINK_INFO_TEXT":
    "Esta funcionalidad permite crear grupos de enlaces y otorgar acceso a los usuarios que correspondan.<br /><br />Usuarios con rol <strong>Finanzas</strong> o <strong>Solo Lectura</strong> podrán ser relacionados a varios Enlaces Virtuales. Los <strong>Administradores</strong> tienen acceso completo, sin restricciones.",
  "DEFAULT_VIRTUAL_LINK_INFO_TEXT":
    "Los usuarios que relacione tendrán acceso a visualizar toda la información financiera, sin restricciones.",
  "Categories": "Categorías",
  "Remove": "Remover",
  "Add Child": "Añadir",
  "Add new category": "Añadir nueva categoria",
  "Inflows": "Créditos",
  "Outflows": "Débitos",
  "Are you sure you want to delete this Category?":
    "¿Estás seguro de que quieres eliminar esta categoría?",
  "Related rules will also be removed":
    "Las reglas relacionadas también se eliminarán.",
  "Subcategories will also be removed":
    "Las subcategorías también se eliminarán.",
  "New category": "Nueva categoría",
  "Parent category": "Categoría padre",
  "Parent group": "Grupo padre",
  "Color": "Color",
  "Create new rule": "Crear nueva regla",
  "Create new category": "Crear nueva categoría",
  "Edit rule": "Editar regla",
  "Create": "Crear",
  "Add a Category group": "Agregar un Grupo de categoría",
  "Edit a Category group": "Editar un Grupo de categoría",
  "Related Categories": "Categorias relacionadas",
  "Are you sure you want to delete this Category rule?":
    "¿Estás seguro de que quieres eliminar esta regla de categoría?",
  "Category successfully!": "¡Categoría creada con éxito!",
  "Category successfully saved!": "¡Categoría guardada con éxito!",
  "Category rule successfully!": "¡Regla de categoría creada con éxito!",
  "Category rule successfully saved!":
    "¡Regla de categoría guardada con éxito!",
  "Category rule successfully deleted!":
    "¡Regla de categoría eliminada con éxito!",
  "Category successfully deleted!": "¡Categoría eliminada con éxito!",
  "Related rules and Subcategories will also be removed":
    "Las reglas y subcategorías relacionadas también se eliminarán",
  "Edit transaction categories": "Editar categorías de transacciones",
  "Edit Batch payments categories": "Editar categorías de Pagos en lote",
  "Edit Pix categories": "Editar categorías de Pix",
  "Categories successfully saved!": "¡Categorías guardadas con éxito!",
  "categoryId": "Categoría",
  "CATEGORY": "Categoría",
  "Category": "Categoría",
  "Uruguay - CI": "Uruguay - CI",
  "Argentina - DNI": "Argentina - DNI",
  "Brasil - CI": "Brasil - CI",
  "At least one rule is required.": "Se requiere al menos una regla creada.",
  "Last day balance": "Saldo último día",
  "Add users": "Agregar usuarios",
  "Save and close": "Guardar y cerrar",
  "You can assign the users at another time.":
    "Podes asignar los usuarios en otro momento.",
  "MAIN_CURRENCY_FIELD_INFO_TEXT":
    "Permite seleccionar una moneda de referencia, para visualizar los montos expresados en una única moneda.",
  "Status (only Payment Institution)": "Estado (solo institución de pago)",
  "Reset": "Reiniciar",
  "Rate edited successfully!": "Tasa editada con éxito!",
  "Rate restarted successfully!": "¡Tasa reiniciada con éxito!",
  "Currencies": "Monedas",
  "Activation email sent successfully":
    "¡Correo electrónico de activación enviado correctamente!",
  "Show inactive accounts": "Mostrar cuentas inactivas",
  "Not connected": "No conectado",
  "We couldn't process this Link.": "No pudimos procesar el enlace.",
  "status": "Estado",
  "country": "País",
  "Last day": "Saldo último día",
  "Beginning of day": "Saldo comienzo del día",
  "Mode": "Modo",
  "mode": "Modo",
  "AUTOMATIC": "Automático",
  "MANUAL": "Manual",
  "MANUAL_DEPOSIT": "Vencimiento CDBs",
  "MANUAL_COMMITTED": "Vencimiento compromisadas",
  "Secondary Point of contact": "Punto de contacto secundario",
  "Group by": "Agrupar por",
  "Group by Owner": "Agrupar por empresa",
  "Search and filter by Currency, Owner, Institution":
    "Buscar y filtrar por Moneda, Empresa e Institución",
  "Number": "Número",
  "Branch": "Agencia",
  "Transaction data": "Datos de la transacción",
  "Application data": "Datos de la aplicación",
  "Institution detail": "Detalle de la institución",
  "Copy detail": "Copiar detalle",
  "Information not valid as receipt": "Información no válida como recibo",
  "Transaction detail": "Detalle de transacción",
  "INSTITUTION DETAIL": "Detalle de institución",
  "TRANSACTION DATA": "Datos de transacción",
  "ACCOUNT DETAIL": "Detalle de la cuenta",
  "INVESTMENT DETAIL": "Detalle de inversión",
  "ADDITIONAL INFORMATION": "Información Adicional",
  "Links created": "Links creados",
  "Workspace successfully created!": "¡Espacio de trabajo creado con éxito!",
  "Workspace successfully saved!": "¡Espacio de trabajo guardado con éxito!",
  "Workspace successfully deleted!": "¡Espacio de trabajo eliminado con éxito!",
  "View Workspace": "Ver espacio de trabajo",
  "Create a Workspace": "Crea un espacio de trabajo",
  "Edit Workspace": "Editar espacio de trabajo",
  "Are you sure you want to delete this Workspace?":
    "¿Estás seguro de que quieres eliminar este espacio de trabajo?",
  "Pending Device Registration": "Registro de dispositivo pendiente",
  "An admin/master user must approve the registration of the device":
    "Un usuario administrador/maestro debe aprobar el registro del dispositivo",
  "Device registration": "Registro de dispositivo",
  "Almost there!": "¡Casi ahí!",
  "This institution requieres an Admin user to approve this registration in order to start processing information.":
    "Esta institución requiere que un usuario administrador apruebe este registro para comenzar a procesar información.",
  "None": "Ninguna",
  "Some links need to be updated manually. Please update them.":
    "Algunos enlaces precisan ser actualizados manualmente. Por favor actualícelos.",
  "Some accounts are not updated. Please update them.":
    "Algunas cuentas no fueron actualizadas hoy. Por favor actualícelas.",
  "UP_TO_DATE_YES": "Si",
  "UP_TO_DATE_NO": "No",
  "Updated on the day": "Actualizada hoy",
  "upToDate": "Actualizada hoy",
  "View accounts": "Ver cuentas",
  "The information is being processed. {{linksCount}} links have been sent for processing.":
    "La información esta siendo procesada. Se han enviado {{linksCount}} enlaces para su procesamiento.",
  "The information is being processed.":
    "La información esta siendo procesada.",
  "in process": "en proceso",
  "Fee": "Comisión",
  "FEE": "Comisión",
  "Service Cost": "Costo de servicio",
  "Taxes": "Impuestos",
  "Tax": "Impuesto",
  "Sale Method": "Método de venta",
  "Voucher": "Voucher",
  "Masked Card": "Tarjeta",
  "Check Serial Number": "Número de serie",
  "Check Number": "Número de cheque",
  "Are you sure you want to disable the account?":
    "¿Estás seguro de que quieres deshabilitar la cuenta?",
  "Create a dedicated space to share specific financial information with users within a workspace.":
    "Cree un espacio dedicado para compartir información financiera específica con usuarios dentro de un workspace.",
  "administrates the subscription and all the workspaces.":
    "Administra la suscripción y todos los workspaces.",
  "has all the permissions to administrate a workspace.":
    "Posee todos los permisos para administrar un workspace.",
  "has access to financial information. Can add and refresh links.":
    "Acceso a información financiera. Puede agregar y actualizar enlaces.",
  "has access only to the technical modules.":
    "Tiene acceso únicamente a los módulos técnicos.",
  "similar to the Finance role, but can't add/refresh links.":
    "Similar al rol Finanzas, pero no puede agregar/actualizar links.",
  "Share specific financial information with other users within a workspace.":
    "Comparta información específica con otros usuarios dentro del workspace.",
  "What would you like to name your Workspace?":
    "¿Cómo le gustaría llamar a su espacio de trabajo?",
  "Every customer starts with one workspace. You can create more depending on the financial information you need to share with specific users based on their role within your company.":
    "Cada cliente comienza con un workspace. Puede crear más según la información financiera que necesite compartir con otros usuarios dentro de la empresa.",
  "General Admin": "Administrador General",
  "Workspaces": "Espacios de trabajo",
  "Workspace": "Espacio de trabajo",
  "{{company}}'s workspaces": "Espacios de trabajo de {{company}}",
  "{{company}}'s views": "Vistas de {{company}}",
  "Check out the workspaces already available.":
    "Echa un vistazo a los espacios de trabajo ya disponibles.",
  "Identity": "Identidad",
  "Activate": "Activar",
  "Security": "Seguridad",
  "User Activation": "Activación del usuario",
  "Please login to activate the workspace.":
    "Inicie sesión para activar el espacio de trabajo.",
  "Back to login page": "Volver a la página de login",
  "Workspace successfully activated!":
    "¡Espacio de trabajo activado con éxito!",
  "Workspace is being activated": "El espacio de trabajo se está activando",
  "Copy": "Copiar",
  "Link info": "Información de enlace",
  "Account info": "Información de la cuenta",
  "N° account": "N° de cuenta",
  "PERIOD_ONE_TIME": "No se repite",
  "PERIOD_MONTHLY": "Cada mes, el {{day}}",
  "PERIOD_WEEKLY": "Cada semana, el {{day}}",
  "PERIOD_WEEKDAY": "Lunes a Viernes",
  "PERIOD_MONDAY_TO_SATURDAY": "Lunes a Sábado",
  "PERIOD_EVERYDAY": "Todos los días",
  "PERIOD_WEEKEND": "Fin de semana",
  "PERIOD_START_OF_MONTH": "Inicio de Mes",
  "Sync Mode": "Modo de sincronización",
  "Sync Type": "Tipo de sincronización",
  "Information to sync": "Información a sincronizar",
  "Sync period": "Período de sincronización",
  "SYNC_MODES_ACCOUNT": "Saldos de cuentas",
  "SYNC_MODES_TRANSACTION": "Transacciones",
  "SYNC_MODES_INVESTMENT": "Inversiones",
  "SYNC_MODES_PAYMENT": "Pagos",
  "SYNC_MODES_INVESTMENT_MOVEMENT": "Movimientos de inversiones",
  "SYNC_MODES_PAYMENT_RECEIPT": "Comprobantes de pago",
  "SYNC_MODES_PAYMENT_SLIP": "Boletos de pago",
  "SYNC_MODES_PIX_TRANSACTION": "Pix",
  "SYNC_MODES_PERIOD_STATEMENT": "Extracto por período",
  "SYNC_MODES_MONTHLY": "Mensual",
  "SYNC_MODES_ALL": "Todas",
  "Schedule refresh": "Programar actualización",
  "Are you sure you want to delete this schedule?":
    "¿Estás seguro de que quieres eliminar esta actualización?",
  "Schedule successfully saved!": "¡Actualización guardada con éxito!",
  "Schedule created successfully!": "¡Actualización creada con éxito!",
  "Start refresh at": "Comienza el",
  "Time": "Hora",
  "Recurrence": "Repetición",
  "My workspaces": "Mis espacios de trabajo",
  "{{workspaceName}}'s users": "Usuarios de {{workspaceName}}",
  "Pending confirmation": "Confirmación pendiente",
  "Pending invitation": "Invitación pendiente",
  "Successfully unsubscribed!": "¡Se canceló la suscripción con éxito!",
  "Are you sure you want to unsubscribe this Workspace?":
    "¿Estás seguro de que quieres cancelar la suscripción de este espacio de trabajo?",
  "Invitation": "Invitación",
  "Accept": "Aceptar",
  "Decline": "Rechazar",
  "Unsubscribe": "Cancelar la suscripción",
  "Percentage": "Porcentaje",
  "Copy information": "Copiar información",
  "Workspace successfully abandoned!":
    "¡Espacio de trabajo abandonado con éxito!",
  "View successfully abandoned!": "Vista abandonada con éxito!",
  "Are you sure you want to abandon this Workspace?":
    "¿Estás seguro de que quieres abandonar este espacio de trabajo?",
  "Abandon": "Abandonar",
  "Account category": "Categoría de cuenta",
  "SAVING": "Caja de ahorro",
  "CHECKING": "Cuenta corriente",
  "ESCROW": "Cuenta de depósito en garantía",
  "INVESTMENT": "Inversión",
  "INVESTMENTS": "Inversiones",
  "FOOD": "Ticket de alimentación",
  "AUTOMATIC_APP": "Aplicación Automática",
  "CAPITAL_ACCOUNT": "Cuenta de Capital",
  "New schedule": "Nueva actualización",
  "Welcome {{firstName}}!": "Bienvenido {{firstName}}!",
  "Let’s get you started with Datanomik. Please take a look at the following steps.":
    "Comience a operar con Datanomik. Por favor, siga los siguientes pasos.",
  "Manage workspaces": "Administre los workspaces",
  "Manage views": "Administre las vistas",
  "Workspace has been created! Through the settings menu, you can add more workspaces and share them with other users later.":
    "Se ha creado el Workspace! A través del menú Configuración, puede agregar más espacios de trabajo y compartirlos con otros usuarios más tarde.",
  "Invite new users to this workspace. They will have access to the modules according to the assigned role.":
    "Invite a nuevos usuarios a este workspace. Ellos tendran acceso a los módulos que correspondan al rol asignado.",
  "Link your institutions. Normally in 3 single steps you can start visualizing financial information.":
    "Vincula tus instituciones. Normalmente en tan solo 3 pasos puede comenzar a visualizar información financiera.",
  "Create a Link": "Crear enlace",
  "CREATE_LINK_INFO":
    "<strong>Importante:</strong> la información estará disponible en el workspace donde fue creado el enlace.",
  "Connect APIs": "Conecte las APIs",
  "Invite": "Invitar",
  "Add developers to integrate our APIs.":
    "Invite a desarrolladores para integrar nuestras APIs.",
  "Forget lengthy and costly integrations.":
    "Olvida las integraciones largas y costosas.",
  "Skip": "Saltar",
  "Thanks for choosing Datanomik’s Business Gate to manage your finances in one place.":
    "Gracias por elegir Business Gate de Datanomik para gestionar sus finanzas en un solo lugar.",
  "Set up your accounts & gain access to a full financial overview.":
    "Configure sus cuentas y obtenga acceso a una visión financiera completa.",
  "Speed up decision making by visualizing all balances in one place.":
    "Acelere la toma de decisiones al visualizar todos los saldos en un solo lugar.",
  "Analyze transactional data and improve reconciliation processes.":
    "Analice los datos transaccionales y mejore los procesos de conciliación.",
  "Invite other users to join Business Gate. Share workspaces and their specific financial information.":
    "Invite a otros usuarios a unirse a Business Gate. Comparta el workspace e información financiera específica.",
  "Link your institutions to the platform and start using Business Gate.":
    "Vincule sus instituciones a la plataforma y comience a utilizar Business Gate.",
  "Connect your institutions to the platform and take advantage of Business Gate.":
    "Conecte sus instituciones a la plataforma y aproveche Business Gate.",
  "Will you be the one to connect all of your institutions? If this is not the case, don't worry; you may skip this step and invite new users later.":
    "¿Será usted el que conecte todas sus instituciones? Si este no es el caso, no te preocupes; Puede omitir este paso e invitar a nuevos usuarios más tarde.",
  "Start": "Comenzar",
  "Default Workspace successfully saved!":
    "¡Espacio de trabajo predeterminado guardado con éxito!",
  "Edit credential": "Editar credencial",
  "You have some negative balances": "Tienes algunos saldos negativos",
  "It seems there are no links created in this workspace.":
    "Parece que no hay enlaces creados en este workspace.",
  "Start linking institutions in 3 singles steps: select country, select institution, and login. That’s it!":
    "Empieza a conectar instituciones en 3 simples pasos: selecciona el país, selecciona la institución e inicia sesión. Y listo!",
  "*Every user in this workspace will be able to access information of the links you create.":
    "*Todos los usuarios de este workspace podrán acceder a la información de los enlaces que crees.",
  "Please contact your workspace admin for more information.":
    "Póngase en contacto con el administrador para más información.",
  "Document": "Documento",
  "Document Type": "Tipo de Documento",
  "Check last updates": "Consulte las últimas actualizaciones",
  "Active clients": "Compañías activas",
  "Select Client": "Seleccionar compañía",
  "Change Client": "Cambiar de cliente",
  "Swift code": "Código SWIFT",
  "Net Value": "Valor Neto",
  "Gross Value": "Valor Bruto",
  "Gross value": "Valor bruto",
  "Type of investment": "Tipo de inversión",
  "netBalanceLte": "Valor Neto <=",
  "netBalanceGte": "Valor Neto >=",
  "grossBalanceGte": "Valor Bruto >=",
  "grossBalanceLte": "Valor Bruto <=",
  "STOCKS": "Stocks",
  "BOND": "Bonos",
  "FUND": "Fondo",
  "DEPOSIT": "Renta fija",
  "DEPOSIT,COMMITTED": "Renta fija",
  "COMMITTED": "Comprometida",
  "COE": "COE",
  "Coe": "COE",
  "Show investments": "Mostrar inversiones",
  "Hide investments": "Ocultar inversiones",
  "Last day position": "Posición del último día",
  "Beginning of day position": "Posición de comienzo del día",
  "Current position": "Posición actual",
  "Current": "Actual",
  "Position": "Posición",
  "Applications": "Aplicaciones",
  "Operation": "Operación",
  "Instrument": "Instrumento",
  "instrumentType": "Instrumento",
  "Expiration": "Vencimiento",
  "dueDate": "Vencimiento",
  "Application expired": "Vence hoy",
  "Applied value": "Valor aplicado",
  "Return": "Remuneración",
  "Current value": "Valor actual",
  "Profit ($)": "Rentabilidad ($)",
  "Profit": "Rentabilidad",
  "Gross Profit": "Rentabilidad Bruta",
  "Net Profit": "Rentabilidad Neta",
  "Date application": "Fecha",
  "Application date": "Fecha",
  "Applications detail": "Detalle de aplicaciones",
  "Available position": "Posición disponible",
  "Investments": "Inversiones",
  "Installments": "Cuotas",
  "Cash Position": "Posición de Caja",
  "Forecasted Cash Position": "Posición de caja proyectada",
  "Position in {{currency}}": "Posición en {{currency}}",
  "The maximum size is 64 characters": "El tamaño máximo es de 64 caracteres.",
  "The maximum size is 128 characters":
    "El tamaño máximo es de 128 caracteres.",
  "USER": "Usuario",
  "General Administrators": "Administradores generales",
  "Add new General Admin": "Agregar nuevo administrador general",
  "New General Admin": "Nuevo administrador general",
  "Please select a registered User in order to assign this category":
    "Seleccione un usuario registrado para asignar esta categoría",
  "General admin successfully saved!":
    "¡Administrador general guardado con éxito!",
  "General admin successfully removed!":
    "¡Administrador general eliminado con éxito!",
  "Remove category": "Eliminar la categoría",
  "Are you sure you want to remove him/her as General Administrator?":
    "¿Estás seguro de que quieres eliminarlo como administrador general?",
  "Reports": "Reportes",
  "Report": "Reporte",
  "Transactions Report": "Reporte de Transacciones",
  "You do not have assigned workspaces": "No tienes workspaces asignados",
  "{{from}}-{{to}} of {{count}} records":
    "{{from}}-{{to}} de {{count}} registros",
  "Something went wrong!": "¡Algo salió mal!",
  "Customize your own reports!": "¡Personaliza tus propios informes!",
  "Select one of the following options and create your financial reports":
    "Seleccione una de las siguientes opciones y cree sus informes financieros",
  "Create a Report": "Crear un reporte",
  "Generate Report": "Generar Reporte",
  "New report": "Nuevo reporte",
  "label.consolidatedPositionByDay": "Posición consolidada por día",
  "Consolidated balances per account groups by date.":
    "Posicion consolidada por grupos de cuentas por fecha.",
  "Contains information of your accounts and balances":
    "Contiene información de sus cuentas y saldos",
  "Contains information of all the debits and credits in your accounts":
    "Contiene información de todos los débitos y créditos en sus cuentas",
  "Permissions": "Permisos",
  "Workspace Permissions: {{workspace}}": "Control de Acceso: {{workspace}}",
  "Group": "Grupo",
  "Create group": "Crear grupo",
  "Save group": "Guardar grupo",
  "New Group": "Nuevo Grupo",
  "New permission": "Nuevo",
  "Permission group successfully saved!":
    "¡Grupo de permisos guardado con éxito!",
  "Permission group successfully updated!":
    "¡Grupo de permisos actualizado con éxito!",
  "Are you sure you want to remove this permission group?":
    "¿Estás seguro que quieres eliminar este grupo de permisos?",
  "Permission group successfully deleted!":
    "¡Grupo de permisos eliminado con éxito!",
  "Group Name": "Nombre del grupo",
  "In order to limit user access to links inside a workspace, define groups of permissions.":
    "Para limitar permisos de usuario dentro de un espacio de trabajo, debes definir grupos de permisos.",
  "Create a group name, choose the links you want to conceal or reveal.":
    "Crea el nombre de grupo, elige los links que quieres ocultar o revelar.",
  "Access": "Acceso",
  "No access": "Sin acceso",
  "Show": "Mostrar",
  "Hide": "Ocultar",
  "Select option": "Seleccionar opción",
  "List of links": "Lista de links",
  "List of users": "Lista de usuarios",
  "Search user": "Buscar usuario",
  "GROUP_COMPANY": "Empresa",
  "GROUP_WORKSPACE": "Espacio de trabajo",
  "({{count}}) Options": "({{count}}) en total",
  "Total Investments": "Total Inversiones",
  "TOTAL_INVESTMENTS_INFO_TEXT":
    "Esta sección presenta la suma de los valores netos de todas las inversiones en cada moneda. Consulte las últimas actualizaciones.",
  "Investments / Institution": "Inversiones / Banco",
  "Investments / Owner": "Inversiones / Empresa",
  "Investments / Account Tag": "Inversiones / Etiqueta de cuenta",
  "Investments / Account group": "Inversiones / Grupo de cuenta",
  "Investments / Owner Tag": "Inversiones / Etiqueta de la empresa",
  "INVESTMENTS_INSTITUTION_INFO_TEXT":
    "Este gráfico presenta cómo se distribuyen sus saldos de inversiones en cada moneda por institución.",
  "INVESTMENTS_GENERAL_OWNER_TAG_INFO_TEXT":
    "Este gráfico presenta cómo se distribuyen sus saldos de inversiones en cada moneda por etiqueta de la empresa.",
  "INVESTMENTS_ACCOUNT_TAG_INFO_TEXT":
    "Este gráfico presenta cómo se distribuyen sus saldos de inversiones en cada moneda por etiqueta de cuenta.",
  "INVESTMENTS_ACCOUNT_GROUP_INFO_TEXT":
    "Este gráfico presenta cómo se distribuyen sus saldos de inversiones en cada moneda por grupo de cuenta.",
  "Investments / type": "Inversiones / Tipo",
  "INVESTMENTS_TYPE_INFO_TEXT":
    "Este gráfico presenta cómo sus inversiones en cada moneda se distribuyen por tipo.",
  "Investments evolution": "Evolución de las inversiones",
  "INVESTMENTS_EVOLUTION_INFO_TEXT":
    "Este gráfico presenta cómo evolucionan las inversiones (valores netos) con el tiempo. Puede aplicar filtros.",
  "Authorized IPs": "IPs autorizadas",
  "Add new IP": "Agregar nueva IP",
  "Are you sure you want to remove this IP Address?":
    "¿Estás seguro de que quieres eliminar esta dirección IP?",
  "IP Address successfully deleted!": "¡Dirección IP eliminada con éxito!",
  "Add new IP address": "Agregar nueva dirección IP",
  "Add IP address": "Crear dirección IP",
  "IP Address successfully created!": "¡Dirección IP creada con éxito!",
  "Edit IP address": "Editar dirección IP",
  "Save IP address": "Guardar dirección IP",
  "IP Address successfully saved!": "¡Dirección IP guardada con éxito!",
  "Contains information on the position of each investment":
    "Contiene información sobre la posición de cada inversión",
  "Financial Position": "Posición Financiera",
  "Contains information of your accounts, balances and investments all together":
    "Contiene información de sus cuentas, saldos e inversiones en conjunto",
  "Historical balances": "Saldos históricos",
  "Balance Evolution": "Evolución de saldos",
  "Contains information of historical balances of all the accounts":
    "Contiene información de saldos históricos de todas las cuentas",
  "Partially registered": "Parcialmente registrado",
  "Partially": "Parcialmente",
  "Go to report": "Ir al reporte",
  "Net Position / Institution": "Posición neta / Institución",
  "Total Financial Position": "Posición financiera total",
  "Financial Position / Institution": "Posición financiera / Institución",
  "Financial Position / Owner": "Posición financiera / Empresa",
  "Financial Position / Account Tag":
    "Posición financiera / Etiqueta de cuenta",
  "Financial Position / Account group": "Posición financiera / Grupo de cuenta",
  "Financial Position / Owner Tag":
    "Posición financiera / Etiqueta de la empresa",
  "Financial Position / Country": "Posición financiera / País",
  "Financial Evolution": "Evolución financiera",
  "Financial Position / type": "Posición financiera / Tipo",
  "Debits / Category": "Débitos por Categoría",
  "GENERAL_TOTAL_INFO_TEXT":
    "Esta sección presenta la suma de los valores netos de todas las inversiones y los saldos corrientes de las cuentas en cada moneda. Consulte las últimas actualizaciones.",
  "GENERAL_INSTITUTION_INFO_TEXT":
    "Este gráfico presenta cómo se distribuye la posición financiera en cada moneda por institución.",
  "GENERAL_COUNTRY_INFO_TEXT":
    "Este gráfico presenta cómo se distribuye la posición financiera en cada moneda por país.",
  "GENERAL_GENERAL_OWNER_TAG_INFO_TEXT":
    "Este gráfico presenta cómo se distribuye la posición financiera en cada moneda por etiqueta de la empresa.",
  "GENERAL_ACCOUNT_TAG_INFO_TEXT":
    "Este gráfico presenta cómo se distribuye la posición financiera en cada moneda por etiqueta de cuenta.",
  "GENERAL_ACCOUNT_GROUP_INFO_TEXT":
    "Este gráfico presenta cómo se distribuye la posición financiera en cada moneda por grupo de cuenta.",
  "GENERAL_CREDITS_DEBITS_AND_BALANCE_EVOLUTION_INFO_TEXT":
    "Este gráfico presenta la evolución de la situación financiera a lo largo del tiempo. Puede aplicar filtros.",
  "GENERAL_TYPE_INFO_TEXT":
    "Este gráfico presenta cómo se distribuye la posición financiera en cada moneda por liquidez y tipo de inversión.",
  "GENERAL_NET_POSITION_PER_INSTITUTION_INFO_TEXT":
    "Este gráfico presenta la suma de créditos y débitos por institución, y la posición neta resultante. No incluye inversiones. Puede aplicar filtros.",
  "Total Position": "Posición total",
  "≈ Total Position": "≈ Posición total",
  "Account Balance": "Saldos de cuentas",
  "Account balance": "Saldo de cuenta",
  "is between": "está entre",
  "contains": "contiene",
  "Value net of taxes and fees, available to rescue.":
    "Valor neto de impuestos y tasas, disponible para rescate.",
  "Blocked balance": "Saldo bloqueado",
  "Judicial blocked balance": "Saldo bloqueado judicial",
  "Overdraft Limit Check": "Límite cheque empresa",
  "Overdraft Limit": "Sobregiro",
  "Taxes Provision": "Provisión de impuestos",
  "Add new General Owner": "Agregar nuevo Grupo de Empresas",
  "Edit General Owner": "Editar Grupo de Empresas",
  "Add General Owner": "Agregar empresa",
  "Save General Owner": "Guardar empresa",
  "General Owner successfully created!": "¡Empresa creada con éxito!",
  "General Owner successfully saved!": "¡Empresa guardada con éxito!",
  "General Owner successfully deleted!": "¡Empresa eliminada con éxito!",
  "Are you sure you want to remove this General Owner?":
    "¿Estás seguro de que quieres eliminar este Grupo de Empresas?",
  "Reassign": "Reasignar",
  "Reassign General Owner": "Reasignar empresa",
  "General Owner": "Grupo de Empresas",
  "General Owners": "Grupos de Empresas",
  "Sync General Owners": "Sincronizar Empresas",
  "Sync General Owners successfully!": "¡Empresas sincronizadas con éxito!",
  "Links Sync Schedule": "Programaciones sincronización de enlaces",
  "Execution name": "Nombre de ejecución",
  "Reassign Owner successfully saved!": "¡Empresa reasignada con éxito!",
  "Updating": "Actualizando",
  "Bank Statements": "Extracto bancario",
  "Format": "Formato",
  "Request Statement": "Solicitar extracto",
  "Bank statement request": "Solicitud de extracto bancario",
  "Request for bank statements received. Check status in downloads menu.":
    "Se registro la solicitud de extracto bancario. Para verificar el estado lo puede visualizar en el menu de descargas.",
  "Check Downloads": "Ver descargas",
  "Request another statement": "Solicitar otro extracto",
  "Request Date": "Fecha de solicitud",
  "requestDate": "Fecha de solicitud",
  "No results": "Sin resultados",
  "NO_ROWS": "Sin resultados",
  "Download": "Descargar",
  "Downloads": "Descargas",
  "New Report": "Generar",
  "Download as ZIP": "Descargar ZIP",
  "Download successfully": "Descarga con éxito",
  "You need to reassign owners before the list shows any entries.":
    "Debes reasignar empresas para que la lista muestre entradas.",
  "Completed": "Terminada",
  "COMPLETED": "Terminada",
  "Sync Status": "Estado de Sincronización",
  "Account Status": "Estado de Cuenta",
  "Balances Status": "Estado de Saldos",
  "Transactions Status": "Estado de Transacciones",
  "Investments Status": "Estado de Inversiones",
  "syncStatus": "Estado de Sincronización",
  "accountSyncStatus": "Estado de Saldos",
  "trxSyncStatus": "Estado de Transacciones",
  "investmentSyncStatus": "Estado de Inversiones",
  "paymentSyncStatus": "Estado de Pagos",
  "invMovementSyncStatus": "Estado de movimientos de inversiones",
  "paymentReceiptSyncStatus": "Estado de Comprobante de pago",
  "paymentSlipSyncStatus": "Estado de Boleto de pago",
  "pixTransactionSyncStatus": "Estado de Pix",
  "Payments Status": "Estado de Pagos",
  "Fail": "Fallida",
  "FAIL": "Fallida",
  "FAILED": "Fallida",
  "Link sync Fail": "Fallida",
  "Includes the available balance in checking account and the invested money net of taxes and fees.":
    "Incluye el saldo disponible en cuenta corriente y las inversiones netas de impuestos y tasas.",
  "New Dashboard": "Nuevo dashboard",
  "Dashboards": "Dashboards",
  "Two Factor Authentication": "Autenticación de dos factores",
  "Is an additional security level to prevent others from accessing private information. When logging in, you may be asked to input a 6-digit token.":
    "Es un nivel de seguridad adicional para evitar que otras personas accedan a información privada. Al iniciar sesión, es posible que se le pida que introduzca un token de 6 dígitos.",
  "The next time you log in, you will be prompted to enable Google Authenticator. Occasionally you may be required to provide a 6-digit token.":
    "La próxima vez que inicie sesión, se le pedirá que habilite Google Authenticator. Ocasionalmente, es posible que se le solicite proporcionar un token de 6 dígitos.",
  "Are you sure you want to disable Two Factor Authentication?":
    "¿Estás seguro de que quieres deshabilitar la autenticación de dos factores?",
  "Confirm": "Confirmar",
  "Reset Token": "Reiniciar Token",
  "Token reset successfully!": "¡Token reiniciado con éxito!",
  "Are you sure you want to reset {{userName}}’s Token?":
    "Estas seguro que quieres reiniciar el token de {{userName}}?",
  "Set up Google Authenticator": "Configure Google Authenticator",
  "Please install the Google Authenticator app on your device, and then scan the QR code below to set up two-factor authentication (2FA) for the first time.":
    "Por favor, instale la aplicación Google Authenticator en su dispositivo y luego escanee el código QR debajo para configurar la autenticación de dos factores (2FA).",
  "Please insert here the token generated (6 digits).":
    "Por favor, ingrese aquí el token generado (6 dígitos).",
  "Two-factor authentication (2FA)": "Autenticación de dos factores (2FA)",
  "Assign Permissions": "Asignar permisos",
  "Tag account": "Etiquetar cuenta",
  "Tag successfully deleted!": "¡Etiqueta eliminada con éxito!",
  "Add Tag": "Añadir etiqueta",
  "View Tag": "Ver etiqueta",
  "Tag successfully created!": "¡Etiqueta creada con éxito!",
  "Tag successfully saved!": "¡Etiqueta guardada con éxito!",
  "Edit Tag": "Editar etiqueta",
  "Add new Tag": "Agregar nueva etiqueta",
  "Are you sure you want to remove this Tag?":
    "¿Estás seguro de que quieres eliminar esta etiqueta?",
  "Tag management": "Gestión de etiquetas",
  "Tag": "Etiqueta",
  "Tags": "Etiquetas",
  "accountTagId": "Etiqueta de cuenta",
  "New Account group": "Nuevo grupo de cuentas",
  "Account group successfully created!": "¡Grupo de cuenta creado con éxito!",
  "Account group successfully saved!": "¡Grupo de cuenta guardado con éxito!",
  "Account group edited successfully!": "¡Grupo de cuenta editado con éxito!",
  "Account group successfully deleted!":
    "¡Grupo de cuenta eliminado con éxito!",
  "Are you sure you want to remove this Account group?":
    "¿Estás seguro de que quieres eliminar este grupo de cuenta?",
  "Account group management": "Gestión de grupo de cuentas",
  "Account group": "Grupo de cuentas",
  "Account group list": "Lista de grupos de cuentas",
  "accountGroupId": "Grupo de cuentas",
  "Resend mobile verification code": "Reenviar vía móvil",
  "Resend email verification code": "Reenviar vía email",
  "Resend invitation": "Enviar por SMS",
  "Resend mobile invitation successfully":
    "Reenvío de invitación vía SMS con éxito",
  "Share (%)": "Particip. (%)",
  "Transaction created successfully!": "¡Transacción creada con éxito!",
  "Add record": "Agregar",
  "Data entry": "Entrada de datos",
  "generalOwnerTagId": "Etiqueta de la empresa",
  "Tag list": "Lista de etiquetas",
  "Tag owner": "Etiquetar empresa",
  "New tag": "Nueva etiqueta",
  "Owner tag": "Etiqueta de la empresa",
  "Account tag": "Etiqueta de cuenta",
  "All account tags": "Todas",
  "Add manually": "Agregar manualmente",
  "Transaction deleted successfully!": "¡Transacción eliminada con éxito!",
  "Are you sure you want to delete this Transaction?":
    "¿Estás seguro de que quieres eliminar esta transacción?",
  "Transaction updated successfully!": "¡Transacción actualizada con éxito!",
  "There are links with automatic refresh schedules; if necessary, add this new link to those rules.":
    "Hay enlaces con refrescos programados; de ser necesario, agregue este nuevo enlace a esas reglas.",
  "Assign Ownership": "Asignar propiedad",
  "Ownership": "% Propiedad",
  "% Ownership": "% Propiedad",
  "Assign Percentage": "Porcentaje de asignación",
  "The percentage must be less than or equal to 100.":
    "El porcentaje debe ser menor o igual a 100.",
  "The percentage must be greater than or equal to 0.":
    "El porcentaje debe ser mayor o igual a 0.",
  "The value must be greater than or equal to 0.":
    "El valor debe ser mayor o igual a 0.",
  "The value must be less than or equal to {{availableBalance}}.":
    "El valor debe ser menor o igual a {{availableBalance}}.",
  "The value must be greater than 0.": "El valor debe ser mayor a 0.",
  "The value must be greater than {{availableBalance}}.":
    "El valor debe ser mayor a {{availableBalance}}.",
  "The value must be greater than or equal to {{availableBalance}}.":
    "El valor debe ser mayor o igual a {{availableBalance}}.",
  "The difference must be greater than or equal to {{availableBalance}}.":
    "La diferencia debe ser mayor o igual a {{availableBalance}}.",
  "Request now": "Solicitar ahora",
  "Schedules": "Agendar",
  "New Bank statements schedule": "Nuevo",
  "Starts at": "Empieza",
  "Repetition": "Repetición",
  "N° Days": "N° Días",
  "Quick access": "Acesso rápido",
  "Last": "Últimos",
  "To schedule": "Agendar solicitud",
  "When selecting a link, we will request the bank statements of all accounts associated with this link":
    "Al seleccionar un enlace, solicitaremos los extractos bancarios de todas las cuentas asociadas con este enlace",
  "DAY_TYPE_DAYS": "Últimos {{days}} días",
  "DAY_TYPE_THIS_MONTH": "Este mes",
  "DAY_TYPE_LAST_MONTH": "Mes pasado",
  "SYNC_LAST_MONTH": "Mes pasado",
  "SYNC_LAST_WEEK": "Semana pasada",
  "SYNC_LAST_BUSINESS_DAY": "Último día hábil",
  "SYNC_NOW": "Información del día",
  "Bank statements schedule successfully!": "¡Solicitud creada con éxito!",
  "Bank statements schedule successfully saved!":
    "¡Solicitud guardada con éxito!",
  "Are you sure you want to remove this Bank statements schedule?":
    "¿Estás seguro de que quieres eliminar esta solicitud?",
  "Bank statements schedule successfully deleted!":
    "¡Solicitud eliminada con éxito!",
  "Report created successfully!": "¡Reporte creado con éxito!",
  "Report saved successfully!": "¡Reporte guardado con éxito!",
  "Save report": "Guardar reporte",
  "Report already exists": "Informe ya existe",
  "Report deleted successfully!": "Reporte eliminado con éxito!",
  "Are you sure you want to remove this Report?":
    "¿Estás seguro de que quieres eliminar este reporte?",
  "Token was sent to": "Token enviado a",
  "Token expires in 1 minute": "El token expira en 1 minuto",
  "The maximum waiting time has elapsed, refresh the page or contact your administrator.":
    "El tiempo de espera máximo ha transcurrido, actualiza la página o comuníquese con su administrador.",
  "Minimum and maximum cash": "Caja mínima y máxima",
  "Minimum and maximum cash target": "Meta de Caja mínima y máxima",
  "Cash target": "Meta de caja",
  "Cash limits": "Límites de caja",
  "Target": "Meta",
  "Source: Bank": "Fuente: Banco",
  "Source: File": "Fuente: Archivo",
  "Source: ERP": "Fuente: ERP",
  "Set minimum and maximum cash limits per currency to optimize the management of your account balances.":
    "Establezca límites mínimos y/o máximos de su caja por moneda, para optimizar la gestión de los saldos de sus cuentas.",
  "Set minimum and/or maximum cash limits for this specific account.":
    "Establezca límites mínimos y/o máximos de caja para esta cuenta específica.",
  "Minimum cash": "Caja mínima",
  "Maximum cash": "Caja máxima",
  "Account balance limit deleted successfully!":
    "Límite de caja eliminado con éxito!",
  "Are you sure you want to delete this account balance limit?":
    "¿Estás seguro de que quieres eliminar este límite de caja?",
  "Account balance limit successfully saved!":
    "¡Límite de caja guardado con éxito!",
  "Account balance limit successfully updated!":
    "¡Límite de caja actualizado con éxito!",
  "Surplus": "Excedente",
  "To cover": "A cubrir",
  "No rules created yet": "No hay reglas creadas todavía",
  "Add all new links to this scheduled refresh.":
    "Agregar todo nuevo link a esta actualización programada.",
  "All new links will be added to this scheduled refresh.":
    "Todo nuevo link será agregado a esta actualización programada.",
  "Add \"{{tagName}}\"": "Agregar \"{{tagName}}\"",
  "Please verify the entered information.": "Verifique los datos ingresados.",
  "Please verify the entered credentials.":
    "Verifique las credenciales ingresadas.",
  "It was not possible to connect with the Institution.":
    "No fue posible conectar con la Institucion.",
  "The user used does not have the required permissions.":
    "El usuario utilizado no posee los permisos requeridos.",
  "You already have an open session in the Institution. Please close the session and try again.":
    "Ya posee una sesión abierta en el Banco. Por favor cierre la sesión e intente nuevamente.",
  "Connection not possible. The user used has second-factor authentication.":
    "No es posible conectar. El Usuario utilizado posee segundo factor de autenticación.",
  "Retry": "Intentar nuevamente",
  "Please try again later": "Intentar luego",
  "Institution linked!": "¡Institución conectada!",
  "This institution requires an Master user to accept this registration within the home banking.":
    "La institución requiere que un usuario Admin/Master acepte este registro de dispositivo dentro del home banking.",
  "We’re processing the information, this might take a while to reflect on the platform.":
    "Estamos procesando la información, esto puede demorar un poco en reflejarse en la plataforma.",
  "Meanwhile, please set up the link refresh frequency.":
    "Mientras tanto, por favor establezca la frecuencia de actualización del enlace.",
  "There is already a link created with the same credentials.":
    "Ya hay un link creado con las mismas credenciales.",
  "Trust this device for 30 days":
    "Confiar en este dispositivo durante 30 días",
  "Device name": "Nombre del dispositivo",
  "Forecast": "Proyectada",
  "Executed": "Realizado",
  "Cash generated throughout the day.":
    "Flujo de caja generado a lo largo del día.",
  "Expected": "Previsto",
  "Further transactions projected to take place throughout the rest of the day.":
    "Transacciones proyectadas que ocurrirán durante el resto del día.",
  "Forecasted Balance": "Saldo proyectado",
  "Add transactions": "Agregar transacciones",
  "File name": "Nombre de archivo",
  "Total registers": "Registros totales",
  "Registers uploaded": "Registros Subidos",
  "Registers with errors": "Registros con errores",
  "Upload file": "Subir archivo",
  "Select file": "Seleccione Archivo",
  "Upload": "Subir",
  "File upload try again":
    "Hubo un error con el archivo.<br />Verifique la extensión o el tamaño.<br /><4>Intentar otra vez</4>.",
  "File successfully upload!": "¡Archivo subido correctamente!",
  "New file": "Archivo nuevo",
  "Download file template": "Descargar plantilla",
  "Create a link refresh schedule.":
    "Cree una actualización programada de enlace.",
  "Existing Link Schedules": "Actualizaciones de enlaces existentes",
  "This link was added to the {{name}} automatic refresh shedule.":
    "Este enlace se agregó a la actualización automatica programada: {{name}}.",
  "Initial position": "Posición inicial",
  "End position of the day": "Posición final del día",
  "Initial balance": "Saldo inicial",
  "End balance of the day": "Saldo final del día",
  "Cash flow": "Flujo de caja",
  "label.cashflow": "Flujo de caja",
  "label.dailyCashflow": "Flujo de caja diario",
  "label.monthlyCashflow": "Flujo de caja mensual",
  "Liquid flow": "Flujo de caja",
  "Accomplished": "Logrado",
  "Projected": "Proyectado",
  "INVESTMENT_BALANCE": "Inversiones",
  "INVESTMENT_BALANCE_END": "Inversiones (posición)",
  "ACCOUNT_BALANCE": "Saldos de cuentas",
  "OTHERS": "Otros",
  "Category group successfully created!":
    "Grupo de categoría creado con éxito!",
  "Category group successfully saved!":
    "Grupo de categoría guardado con éxito!",
  "Cashflow targets successfully saved!":
    "¡Flujo de caja targets guardados con éxito!",
  "Cashflow Configuration": "Configuración de Flujo de caja",
  "Consolidated": "Consolidado",
  "Incompleted": "Incompleto",
  "We couldn't sync this Link completely.":
    "No pudimos sincronizar este enlace por completo.",
  "Link expires in {{time}} minutes": "El enlace expira en {{time}} minutos",
  "Link expires in {{time}}": "El enlace expira en {{time}}",
  "Favourite account successfully saved!":
    "Cuenta favorita guardada con éxito!",
  "Favourite": "Favorito",
  "Open link": "Abrir enlace",
  "Daily": "Diario",
  "Download errors": "Descargar errores",
  "Automatic applications": "Aplicaciones automáticas",
  "Value From": "Valor desde",
  "Value To": "Valor hasta",
  "label.applicationTemplate": "Planilla de Modelo de Aplicación",
  "label.cvcApplicationTemplate":
    "Planilla de Modelo de Aplicaciones y Rescates",
  "label.rescueTemplate": "Planilla de Modelo de Rescate",
  "label.financialPosition": "Posición Financiera",
  "label.financialPositionByOwner": "Posición Financiera por Empresa",
  "label.financialPositionCustom": "Posición Financiera (personalizado)",
  "label.financialPositionExecutive": "Posición Financiera Ejecutiva",
  "label.accounts": "Cuentas",
  "label.accountsCustom": "Cuentas (personalizado)",
  "label.accountsGroupCustom": "Posición Financiera - Grupo de cuentas",
  "label.accountsHistoryCustom": "Cuentas - histórico (personalizado)",
  "label.customs": "Customs",
  "label.historicalBalances": "Saldos Históricos",
  "label.accountsForecastBalance": "Evolución de saldos",
  "label.positionByBusiness": "Posición por negocio",
  "label.investments": "Inversiones",
  "label.investmentsCustom": "Inversiones (personalizado)",
  "label.investmentsHistoryCustom": "Inversiones - histórico (personalizado)",
  "label.investmentsHistory": "Historial de Inversiones",
  "label.investmentMovements": "Movimientos de Inversiones",
  "label.investmentsMonthly": "Inversiones Mensuales",
  "label.investmentsEvolution": "Evolución de Inversiones",
  "label.investmentsMovement": "Movimientos de Inversiones",
  "label.investmentsByMonth": "Inversiones por mes",
  "label.depositMovement": "Movimientos de CDBs",
  "label.fundMovement": "Movimientos de Fondos",
  "label.committedMovement": "Movimientos de Comprometidas",
  "label.automaticApplicationMovement":
    "Movimientos de aplicaciones automáticas",
  "label.automaticApplicationMonthlyBalances":
    "Balance Mensuales de aplicaciones automáticas",
  "label.transactions": "Transacciones",
  "label.transactionNotImpactCashflow":
    "Transacciones que no impactan el cashflow",
  "label.transactionsPaymentsNotImpactCashflow":
    "Pagos que no impactan el cashflow",
  "label.transactionsCategories": "Transacciones con Categorías",
  "label.transactionsByAccount": "Transacciones por Cuenta",
  "label.transactionsManualByAccount": "Transacciones Previstas por Cuenta",
  "label.transactionsByAccountLastDay":
    "Transacciones Por Cuenta De Días Cerrados",
  "label.transactionsDailyPaymentConference": "Conferencia de pago diario",
  "label.transactionsPayments": "Pagos",
  "label.transactionsCategoriesFees": "Tarifas por Mes",
  "label.transactionsIntraCompany":
    "Transferencias entre cuentas de un mismo titular",
  "label.transactionsFeesDaily": "Tarifas por dia",
  "label.weeklyPositionBalances": "Posición de Saldos Semanal",
  "label.favourite": "Favoritos",
  "label.cashFlowByCompany": "Flujo de caja por empresa",
  "label.positionByCompany": "Posición por empresa",
  "label.accountsConsolidatedOwner": "Visión consolidada por Empresa",
  "label.accountsBlockedBalanceEvolution": "Saldos bloqueados históricos",
  "label.dailyBalanceOfApplicationsByInstitution":
    "Saldo diario de solicitudes por Institución",
  "label.dailyApplicationBalancePerOwner":
    "Saldo de solicitud diario por empresa",
  "label.accountsBlockedJudicialBalanceEvolution":
    "Saldos judiciales históricos bloqueados",
  "Historical evolution of blocked balances per account.":
    "Evolución histórica de los saldos bloqueados por cuenta.",
  "Historical evolution of judicially blocked balances, by account.":
    "Evolución histórica de los saldos bloqueados judicialmente, por cuenta.",
  "Surplus balances and balances to be covered, grouped by Owner":
    "Saldos excedentes y a cubrir, agrupados por Empresa",
  "Current cash position per account.": "Posición de caja actual por cuenta.",
  "Current balances per account.": "Saldos del día actual por cuenta.",
  "Historical evolution of balances per account.":
    "Evolución histórica de los saldos por cuenta.",
  "Historical evolution of checking account and investment balances.":
    "Evolución histórica de los saldos de cuenta corriente y de inversión.",
  "Consolidated balances and investments from the previous day, grouped by account and owner tags.":
    "Consolidado de saldos e inversiones del día anterior, agrupado por tags de cuenta y owner.",
  "Cash flow by company.": "Flujo de caja por empresa.",
  "Cash position projection for the day.":
    "Proyección de la posición de caja del día.",
  "Current investment position per account.":
    "Posición actual invertida por cuenta.",
  "Historical evolution of investments per account.":
    "Evolución histórica de las inversiones por cuenta.",
  "Daily balance of applications (by Institution)":
    "Saldo diario de solicitudes (por Institución)",
  "Daily balance of applications (by Owner)":
    "Saldo diario de solicitudes (por empresa)",
  "Monthly position of each investment.": "Posición mensual de cada inversión.",
  "Transaction details for a date range.":
    "Detalle de las transacciones para un rango de fechas.",
  "Transaction details with the categories included.":
    "Detalle de las transacciones con las categorías incluidas.",
  "Applications and withdraws for a date range.":
    "Aplicaciones y rescates en un intervalo de fechas.",
  "Current invested position per application.":
    "Posición actual invertida por aplicación.",
  "Historical invested position per application.":
    "Posición histórica invertida por aplicación.",
  "Position by application, sorted by oldest application date and lowest remuneration.":
    "Posición por aplicación, ordenada por fecha de solicitud más antigua y remuneración más baja.",
  "The platform will connect with Open Finance":
    "La plataforma se conectará con <strong>{{ name }}</strong> a través de conexiones de Open Finance, para obtener una visión financiera completa.",
  "By pressing “Continue”, you confirm acceptance of the Terms and Conditions.":
    "Al continuar, acepta los <2>Términos y Condiciones</2>.",
  "Iniciador is our partner for financial data connection and data sharing. Through Iniciador, you can securely provide us with your data, and you also have the possibility to control and revoke this access at any time.":
    "Iniciador es nuestro socio de conexión y acceso de datos financieros. A través de Iniciador, usted puede proporcionarnos sus datos de manera segura, además de tener la capacidad de controlar y revocar este acceso en cualquier momento.",
  "Iniciador is an institution authorized and regulated by the Central Bank of Brazil, a certified participant of Pix framework and Open Finance Brasil, registered under CNPJ 44.471.172/0001-19.":
    "Iniciador es una institución autorizada y regulada por el Banco Central de Brasil, un participante homologado del acuerdo Pix y de Open Finance Brasil, registrado bajo el CNPJ 44.471.172/0001-19.",
  "Check the terms and conditions.": "Consulte los términos y condiciones.",
  "Terms and conditions": "Términos y condiciones",
  "Learn more about data and deadlines":
    "Obtenga más información sobre los datos y plazos",
  "Data and deadlines": "Datos y plazos",
  "The data that will be shared by your Bank are:":
    "Los datos que serán compartidos por su Banco son:",
  "Account data": "Datos de la cuenta",
  "1. Identification": "Identificación",
  "1. Balances": "Saldos",
  "2. Limits": "Límites",
  "3. Transactions": "Transacciones",
  "Registration data": "Datos de registro",
  "Frequently asked questions": "Preguntas frecuentes",
  "How is the sharing done?": "¿Cómo se realiza el intercambio de datos?",
  "Data sharing is carried out through Iniciador, an institution authorized by the Central Bank of Brazil to connect with other institutions via Open Finance:":
    "El acceso a los datos se lleva a cabo a través de Iniciador, una institución autorizada por el Banco Central de Brasil para conectarse con otras instituciones a través de Open Finance:",
  "Share your account data with Iniciador":
    "Comparta los datos de su cuenta con Iniciador",
  "Through Open Finance, Iniciador collects the banking data you allow and prepares it for secure sharing with us.":
    "A través de <strong>Open Finance</strong>, Iniciador recopila los datos bancarios que usted permita y los prepara para su intercambio seguro con nosotros.",
  "You authorize Iniciador to share with us the account data you are connecting":
    "Usted autoriza a Iniciador a compartir con nosotros los datos de la cuenta que va a conectar",
  "Iniciador acts as your intermediary, allowing only the sharing with us of the data you authorize, protected by the General Data Protection Law.":
    "Iniciador actúa como su intermediario, permitiendo únicamente el intercambio con nosotros de los datos que usted autorice, respaldado por la <strong>Ley General de Protección de Datos</strong>.",
  "What is Open Finance?": "¿Qué es Open Finance? ",
  "Open Finance is the evolution of Open Banking. It refers to the ability of customers of financial products and services to allow the sharing of their information among different institutions authorized by the Central Bank and the movement of their bank accounts from various platforms, not just through the bank's app or website, in a secure, efficient, and convenient manner.":
    "Open Finance es la evolución de Open Banking, o sistema financiero abierto. Se refiere a la capacidad de los clientes de productos y servicios financieros para permitir el intercambio de su información entre diferentes instituciones autorizadas por el Banco Central y la movilización de sus cuentas bancarias desde diversas plataformas, no solo a través de la aplicación o sitio web del banco, de manera segura, eficiente y conveniente.",
  "Who is Iniciador?": "¿Quién es Iniciador?",
  "Iniciador is our partner for financial data connection and sharing. Through Iniciador, you can securely provide us with your data, and you also have the ability to control and revoke this access at any time.":
    "Iniciador es nuestro socio para la conexión y compartición de datos financieros. A través del Iniciador, usted puede proporcionarnos sus datos de manera segura, y también tiene la capacidad de controlar y revocar este acceso en cualquier momento.",
  "Iniciador is an institution authorized and regulated by the Central Bank of Brazil, an approved participant of the Pix Arrangement and Open Finance Brazil, registered under CNPJ 44.471.172/0001-19.":
    "Iniciador es una institución autorizada y regulada por el Banco Central de Brasil, un participante aprobado del Acuerdo Pix y de Open Finance Brasil, registrado bajo el CNPJ 44.471.172/0001-19.",
  "How can I manage my shared data?":
    "¿Cómo puedo gestionar mis datos compartidos?",
  "At any time, you can modify, renew, or cancel your data sharing through the Open Finance Management panel available in the main menu of this application or through the link: portal.iniciador.com.br.":
    "En cualquier momento, puedes modificar, renovar o cancelar el intercambio de tus datos a través del panel de Gestión Open Finance disponible en el menú principal de esta aplicación o mediante el enlace: <2>portal.iniciador.com.br</2>.",
  "Preparing the open finance connection":
    "Preparando la conexión de Open Finance",
  "Summary of the sharing": "Resumen del intercambio",
  "Redirecting to {{name}} in {{count}}":
    "Redireccionando a {{name}} en {{count}}",
  "Open Finance Management": "Gestión Open Finance",
  "It could contain both checking account balances and automatic applications.":
    "Podría contener tanto los saldos de las cuentas corrientes como las aplicaciones automáticas.",
  "Available Cash Position": "Posición total",
  "Includes the Available Balance + Automatic Applications and Investments Net Value.":
    "Incluye el Saldo disponible + Aplicaciones automáticas y las Inversiones Valor Neto.",
  "Add cash account": "Agregar cuenta efectivo",
  "Write to create one": "Escribe para crear uno",
  "Owner successfully created!": "¡Empresa creada con éxito!",
  "Cash Holding account successfully created!":
    "¡Cuenta de efectivo creada con éxito!",
  "Cash Holding account successfully saved!":
    "¡Cuenta de efectivo guardada con éxito!",
  "CASH": "Efectivo",
  "CASH_HOLDING": "Cuenta efectivo",
  "Cash Holding": "Cuenta efectivo",
  "The account has an overdraft limit of {{value}}":
    "La cuenta tiene un límite de descubierto de {{value}}",
  "lbl_full_account_number_ag": "Agencia",
  "Agency": "Agencia",
  "lbl_full_account_number_conta": "Cuenta",
  "lbl_full_account_number_dv": "DV",
  "digitCount_one": "{{count}} dígito",
  "digitCount_other": "{{count}} dígitos",
  "maxDigitCount_one": "Máx. {{count}} dígito",
  "maxDigitCount_other": "Máx. {{count}} dígitos",
  "Schedule successfully deleted!": "¡Actualización eliminada con éxito!",
  "Schedule successfully created!": "¡Actualización creada con éxito!",
  "Withdrawal criteria": "Criterio de rescate",
  "Configuration": "Configuración",
  "Parameters": "Parámetros",
  "Create a schedule": "Crear una actualización",
  "View schedule": "Detalle de actualización",
  "Edit schedule": "Editar actualización",
  "Delete schedule": "Eliminar actualización",
  "Are you sure you want to delete this Report schedule?":
    "¿Estás seguro de que quieres eliminar esta actualización?",
  "User unlocked successfully!": "¡Usuario desbloqueado con éxito!",
  "Unlock": "Desbloquear",
  "Lock": "Bloquear",
  "Are you sure you want to delete the {{name}} workspace?":
    "¿Estás seguro de que quieres eliminar el espacio de trabajo {{name}}?",
  "Performing this action will delete all the links that belong to the workspace and all the information related.":
    "Al realizar esta acción, se eliminarán todos los links que pertenecen al espacio de trabajo y toda la información relacionada.",
  "To confirm the deletion, type the name of the workspace into the field.":
    "Para confirmar la eliminación, escribe el nombre del espacio de trabajo en el campo.",
  "Export to PDF": "Exportar a PDF",
  "Overview config successfully saved!": "¡Configuración guardada con éxito!",
  "Configuration successfully saved!": "¡Configuración guardada con éxito!",
  "Overview Config": "Configuración",
  "Total blocked balance": "Total saldo bloqueado",
  "Idle balance": "Saldo ocioso",
  "Balance in accounts": "Saldo ocioso",
  "Balance in investments": "Inversiones",
  "Accounts with surplus": "Cuentas con excedente",
  "Accounts to cover": "Cuentas para cubrir",
  "Negative accounts": "Cuentas negativas",
  "Deleted": "Eliminada",
  "This account was deleted by the institution.":
    "Esta cuenta fue eliminada por la institución.",
  "Net investment": "Inversión neta",
  "This is an estimated value.": "Este es un valor calculado.",
  "Weekly": "Semanal",
  "You have a total of {{currency}} {{todayAmount}} in investments that expires today.":
    "Tiene un total de {{currency}} {{todayAmount}} en inversiones que vencen hoy.",
  "You have a total of {{currency}} {{todayAmount}} in investments that expires today. You have a total of {{currency}} {{tomorrowAmount}} in investments that expires tomorrow.":
    "Tiene un total de {{currency}} {{todayAmount}} en inversiones que vencen hoy. Tiene un total de {{currency}} {{tomorrowAmount}} en inversiones que vencen mañana.",
  "You have a total of {{currency}} {{tomorrowAmount}} in investments that expires tomorrow.":
    "Tiene un total de {{currency}} {{tomorrowAmount}} en inversiones que vencen mañana.",
  "You have a total of {{currency}} {{amount}} in investments that expires on {{dueDate}}.":
    "Tiene un total de {{currency}} {{amount}} en inversiones que vencen el {{dueDate}}.",
  "Future cash": "Caja futura",
  "Investments expiration": "Expiración de inversiones",
  "There are no investments expiring in the selected period.":
    "No se posee inversiones por vencer en el periodo seleccionado.",
  "There are no future credits or debits reported for the selected period.":
    "No se tienen créditos ni débitos futuros reportados para el período seleccionado.",
  "GENERAL_FUTURE_CASH_INFO_TEXT":
    "Este gráfico presenta los créditos, débitos y vencimiento de inversiones de hoy y de los próximos 6 días.",
  "Committed Applications": "Aplicaciones comprometidas",
  "You have a total of {{currency}} {{amount}} in Deposits that expire today.":
    "Tiene un total de {{currency}} {{amount}} en CDBs que vencen hoy.",
  "You have a total of {{currency}} {{amount}} in COE that expire today.":
    "Tiene un total de {{currency}} {{amount}} en COE que vencen hoy.",
  "You have a total of {{currency}} {{amount}} in Committed investments that expire today.":
    "Tiene un total de {{currency}} {{amount}} en Inversiones comprometidas que vencen hoy.",
  "See here": "Visualice aquí",
  "Committed": "Comprometidas",
  "committed": "Comprometidas",
  "Deposit Applications": "Aplicaciones de CDBs",
  "COMMITTED_APPLICATIONS": "Rescates compromisadas",
  "committedWithdrawName": "Vencimiento compromisadas",
  "DEPOSIT_APPLICATIONS": "Rescates CDBs",
  "depositWithdrawName": "Vencimiento CDBs",
  "Deposit": "Renta fija",
  "Fund Applications": "Aplicaciones de fondos",
  "Fund": "Fondos",
  "Indexer": "Rendimiento relativo",
  "PERFORMANCE": "Inversiones (retornos)",
  "Remaining main balance": "Balance principal restante",
  "Quota balance": "Saldo de cuotas",
  "Quota quantity": "Cantidad de cuotas",
  "Quota gross price value": "Valor bruto del precio de la cuota",
  "Financial Efficiency": "Eficiencia financiera",
  "GENERAL_EFFICIENCY_INFO_TEXT":
    "Este gráfico presenta la eficiencia financiera de la posición de caja tanto de diariamente como mensualmente, calculando el promedio diario de cada mes.",
  "Efficiency": "Eficiencia",
  "Efficiency (%)": "Eficiencia (%)",
  "Investments net value": "Inversiones valor neto",
  "label.accountingTransactions": "Transacciones Contables",
  "Partial errors": "Errores parciales",
  "We are experiencing some connection instability with {{description}}.":
    "Estamos experimentando cierta inestabilidad de conexión con <strong>{{description}}</strong>.",
  "Please check out the last update. We are sorry for the inconvenience.":
    "Consulte la <2>última actualización</2>. Lamentamos las molestias.",
  "label.investmentApplications": "Aplicaciones",
  "label.investmentsAppDeposit": "Renta fija",
  "label.investmentsAppDepositCustom": "Renta fija (personalizado)",
  "label.investmentsAppCommitted": "Comprometidas",
  "label.investmentsAppCommittedCustom": "Comprometidas (personalizado)",
  "label.investmentsAppFund": "Fondos",
  "label.depositApplicationHistory": "Histórico de Aplicaciones de CDBs",
  "label.committedApplicationHistory":
    "Histórico de Aplicaciones Comprometidas",
  "label.fundApplicationHistory": "Histórico de Aplicaciones de Fondos",
  "Help": "Ayuda",
  "To omit": "Omitir",
  "Finish": "Finalizar",
  "Future Transactions": "Transacciones futuras",
  "To be able to forecast balances, we need you to upload information on future credits and debits. Options: manually, by file, and via APIs.":
    "Para poder proyectar los saldos, necesitamos que cargue informacion de creditos y debitos futuros. Opciones: manualmente, por archivo y por APIs.",
  "Categorize your historical and future movements, based on your internal classification.":
    "Categorice sus movimientos históricos y futuros, en base a su clasificación interna.",
  "Targets": "Metas",
  "Double click and incorporate targets to automatically verify their fulfillment.":
    "Haga doble clic e incorpore metas para verificar automáticamente el cumplimiento de las mismas.",
  "Once the targets are incorporated, click on “Save”.":
    "Una vez incorporadas las metas, haga clic en “Guardar”.",
  "Tax on Financial Operations (IOF) is a tax that focuses on the income of financial investments and occurs in the redemptions made within 30 days of the date of application. See detail.":
    "El impuesto sobre las operaciones financieras (IOF) es un impuesto que se centra en los ingresos de las inversiones financieras y ocurre en los reembolsos realizados dentro de los 30 días posteriores a la fecha de solicitud.<br/><br/><3>Ver detalle</3>",
  "Income tax is a tax that focuses on the net income of financial investments decreasing over time. See detail.":
    "El impuesto sobre la renta es un impuesto que se centra en el ingreso neto de las inversiones financieras que disminuyen con el tiempo.<br/><br/><3>Ver detalle</3>",
  "Projected balance in investments": "Saldo proyectado en inversiones",
  "Projected balance in current accounts":
    "Saldo proyectado en cuentas corrientes",
  "forecastDate": "Fecha",
  "label.historicalAutomaticApplications":
    "Aplicaciones Automáticas Históricas",
  "Are you sure you want to delete this classification?":
    "¿Está seguro de que desea eliminar esta clasificación?",
  "Close Panel": "Cerrar Panel",
  "Open Panel": "Abrir Panel",
  "indicatorType": "Indicador",
  "Indicator": "Indicador",
  "SHORTAGE": "Cuentas para cubrir",
  "OVERAGE": "Cuentas con excedente",
  "NEGATIVE": "Cuentas negativas",
  "label.accountsBalanceEvolution": "Evolución de Saldo",
  "label.forcastedCashPosition": "Posición de Caja Proyectada",
  "Active filters": "Filtros activos",
  "One-time Password": "Contraseña de un solo uso",
  "Disabled by the company": "Deshabilitado por la empresa",
  "Provide a one-time password using Google Authenticator or similar.":
    "Proporcione una contraseña de un solo uso utilizando Google Authenticator o un servicio similar.",
  "One-time password enabled succefully!":
    "¡Contraseña de un solo uso habilitada con éxito!",
  "One-time password disabled succefully!":
    "¡Contraseña de un solo uso deshabilitada con éxito!",
  "Optimize": "Optimizar",
  "Criteria": "Criterio",
  "Manage Criteria": "Gestionar criterios",
  "What are the withdrawal criteria?": "¿Cuál es el criterio de rescate?",
  "What is the amount you want to withdraw?": "¿Cuánto precisa rescatar?",
  "Amount to withdraw": "Valor a ser rescatado",
  "Total amount to withdraw": "Valor total a ser rescatado",
  "For which owners do you need to withdraw?":
    "¿Para qué empresas precisa rescatar?",
  "From which institutions do you need to withdraw?":
    "¿De qué instituciones precisa rescatar?",
  "From which accounts do you need to withdraw?":
    "¿De qué cuentas precisa rescatar?",
  "Are you sure you want to remove this Criteria?":
    "¿Estás seguro de que quieres eliminar este criterio?",
  "Criteria successfully deleted!": "¡Criterio eliminado con éxito!",
  "Criteria successfully created!": "¡Criterio creado con éxito!",
  "Criteria successfully saved!": "¡Criterio guardado con éxito!",
  "New": "Nuevo",
  "Lower tax amount": "Menor monto de impuestos",
  "Less remuneration": "Menor remuneración",
  "Lower profitability": "Menor rentabilidad",
  "Lower tax rates": "Menor alícuota de impuestos",
  "Withdraw Finish": "Filtrar",
  "Withdraw Reset": "Reiniciar",
  "Closer to the expiration date": "Más cerca de la fecha de vencimiento",
  "Applications about to expire": "Calendario de vencimientos",
  "{{count}} Applications_one": "{{count}} Aplicación",
  "{{count}} Applications_other": "{{count}} Aplicaciones",
  "You don’t have investments about to expire.":
    "No posee inversiones próximas a vencer.",
  "Impact Cash flow": "Impactar Flujo de caja",
  "label.accountsWeeklyPosition": "Posición semanal",
  "negative balances": "saldos en negativo",
  "balances to cover": "saldo a cubrir en c/c",
  "surplus in balances": "saldo excedente en c/c",
  "Application type": "Tipo de aplicacion",
  "Sync accounts: {{totalAccountProcessed}}/{{total}}":
    "Saldos: {{totalAccountProcessed}} de {{total}} cuentas",
  "Sync account transactions: {{totalTrxProcessed}}/{{total}}":
    "Transacciones: {{totalTrxProcessed}} de {{total}} cuentas",
  "Sync account investments: {{totalInvestmentProcessed}}/{{total}}":
    "Inversiones: {{totalInvestmentProcessed}} de {{total}} cuentas",
  "Sync account payments: {{totalPaymentProcessed}}/{{total}}":
    "Pagos: {{totalPaymentProcessed}} de {{total}} cuentas",
  "Sync account investment movements: {{totalInvMovementProcessed}}/{{total}}":
    "Movimientos: {{totalInvMovementProcessed}} de {{total}} cuentas",
  "Sync account pix: {{totalPixTransactionProcessed}}/{{total}}":
    "Pix: {{totalPixTransactionProcessed}} de {{total}} cuentas",
  "Sync account payment receipts: {{totalPaymentReceiptProcessed}}/{{total}}":
    "Comprobantes de pagos: {{totalPaymentReceiptProcessed}} de {{total}} cuentas",
  "Sync account payment slips: {{totalPaymentSlipProcessed}}/{{total}}":
    "Boletos de pagos: {{totalPaymentSlipProcessed}} de {{total}} cuentas",
  "There are no investments expiring within this date range.":
    "No se registran inversiones que venzan en este rango de fechas.",
  "Schedule report": "Agendar envío",
  "View schedules": "Ver agendamientos",
  "Program": "Programar",
  "Report schedules": "Agendamientos",
  "View Report schedules": "Ver agendamientos",
  "LAST_DAY": "Día anterior",
  "LAST_WORKING_DAY": "Ultimo día hábil",
  "Working days": "Días hábiles",
  "Working days applied": "Días hábiles aplicado",
  "CURRENT_DAY": "Día actual",
  "LAST_WEEK": "Últimos 7 días",
  "LAST_15_DAYS": "Últimos 15 días",
  "LAST_30_DAYS": "Últimos 30 días",
  "LAST_MONTH": "Mes pasado",
  "CURRENT_MONTH": "Mes actual",
  "Month": "Mes",
  "INSTITUTION_STATUS_ONLINE": "Conexión estable",
  "INSTITUTION_STATUS_OFFLINE": "Conexión inestable",
  "INSTITUTION_STATUS_UNSTABLE": "Conexión inestable",
  "Status of all Institutions": "Estado de todas las instituciones",
  "Institutions status": "Estado de instituciones",
  "CASH_FORECASTING": "Efectivo proyectado",
  "Batch payments": "Pagos en lote",
  "Batch number": "Número de Lote",
  "batch": "Número de Lote",
  "PAYMENT_STATUS_NOT_EXECUTED": "No realizado",
  "PIX_STATUS_EXECUTED": "Realizado",
  "PAYMENT_STATUS_EXECUTED": "Realizado",
  "PAYMENT_STATUS_PARTIALLY_AUTHORIZED": "Parcialmente autorizado",
  "PAYMENT_STATUS_AUTHORIZED": "Autorizado",
  "PAYMENT_STATUS_PENDING_EXECUTION": "Ejecución pendiente",
  "PAYMENT_STATUS_UNKNOWN": "Desconocido",
  "PAYMENT_STATUS_SCHEDULED": "Programado",
  "PAYMENT_STATUS_BLOCKED": "Bloqueado",
  "PAYMENT_STATUS_CANCELED": "Cancelado",
  "PAYMENT_STATUS_REFUNDED": "Reintegrado",
  "PAYMENT_STATUS_REJECTED": "Rechazado",
  "PAYMENT_STATUS_PENDING_AUTHORIZATION": "Autorización pendiente",
  "DOWNLOADABLE_STATUS_PENDING": "Pendiente",
  "DOWNLOADABLE_STATUS_REQUESTED": "Solicitado",
  "DOWNLOADABLE_STATUS_IN_PROGRESS": "En progreso",
  "DOWNLOADABLE_STATUS_FAILED": "Fallida",
  "DOWNLOADABLE_STATUS_PROCESSED": "Procesado",
  "downloadable": "Comprobante de pago",
  "The link to your report has expired.": "El enlace a su reporte ha expirado.",
  "Login to the platform to generate a new report.":
    "Ingrese a la plataforma para generar un nuevo reporte.",
  "Unsupported file": "Archivo no compatible",
  "Custom": "Personalizado",
  "Has report schedules": "{{count}} Agendamientos",
  "Select owner": "Selecciona Empresa",
  "Generated on": "Generado el",
  "Favourite report": "Marcar como favorito",
  "The report will be saved according to the previously activated filters.":
    "El reporte se guardará de acuerdo con los filtros activados previamente.",
  "View Reports": "Ver reportes",
  "The report will be sent according to the previously activated filters.":
    "El reporte se enviará de acuerdo con los filtros activados previamente.",
  "Are you sure you want to remove this report from your favourites?":
    "¿Estás seguro de que quieres quitar este reporte de tus favoritos?",
  "Favourite report successfully created!":
    "¡Reporte favorito creado con éxito!",
  "Favourite report successfully edited!":
    "¡Reporte favorito editado con éxito!",
  "Favourite report successfully deleted!":
    "¡Reporte favorito eliminado con éxito!",
  "Mark report as favourite": "Marcar reporte como favorito",
  "Edit favourite report": "Editar reporte favorito",
  "Execute": "Ejecutar",
  "Password Policy": "Política de Contraseña",
  "Password Policy updated succefully!":
    "Política de contraseña actualizada correctamente!",
  "Datanomik Standard": "Estándar de Datanomik",
  "Customized": "Personalizada",
  "Minimum characters": "Caracteres mínimos",
  "characters": "caracteres",
  "Password creation requirements:": "Requisitos de creación de contraseña:",
  "minimum uppercase character (A-Z)": "mínimo en mayúsculas (A-Z)",
  "minimum lowercase character (A-Z)": "mínimo en minúsculas (A-Z)",
  "minimum number (0-9)": "mínimo número (0-9)",
  "minimum special symbol (*!%#$)": "mínimo de símbolo especial (*!%#$)",
  "Other requirements:": "Otros requerimientos:",
  "Request the password exchange for each":
    "Solicite el intercambio de contraseñas para cada",
  "days": "días",
  "Login attempt": "Intento de inicio de sesión",
  "attempts": "intentos",
  "After the number of login attempts, the user will be blocked.":
    "Después del número de intentos de inicio de sesión, el usuario será bloqueado.",
  "Inactivity on the platform": "Inactividad en la plataforma",
  "Maximum inactivity time before blocking use:":
    "Tiempo de inactividad máxima antes de bloquear el uso:",
  "After the days scheduled without access to the platform, the user must again request access to the administrator":
    "Después de los días programados sin acceso a la plataforma, el usuario debe solicitar nuevamente el acceso al administrador",
  "Wrong minimun value": "Valor mínimo incorrecto",
  "Minimum value is 0": "El valor mínimo es 0",
  "Resend": "Reenviar",
  "Report successfully resended!": "Reporte enviado con éxito!",
  "Transaction By Account": "Transacciones por Cuenta",
  "Accounting Transactions": "Transacciones Contables",
  "Transacciones Por Cuenta De Días Cerrados":
    "Transações Por Dia de Fechamento da Conta",
  "Group of categories": "Grupo de categorías",
  "Edit group": "Editar grupo",
  "Edit category": "Editar categoría",
  "Add group": "Crear grupo",
  "Login logs": "Registro de actividad",
  "Log user": "Usuario",
  "Login Date": "Login",
  "Logout Date": "Logout",
  "Activity log history": "Historial de actividades",
  "Session ID": "ID de sesión",
  "Session": "Sesión",
  "Strategic": "Estratégico",
  "Strategic Treasury": "Tesorería Estratégica",
  "Analytical Treasury": "Tesorería Analítica",
  "Smart Cash Pilot": "Piloto de Caja Inteligente",
  "Low performance": "Bajo rendimiento",
  "Efficiency Score": "Puntaje de Eficiencia",
  "Portfolio Performance": "Remuneración del portfolio",
  "Portfolio": "Portfolio",
  "PERFECT!": "Perfecto!",
  "HIGH": "Alto",
  "MEDIUM": "Medio",
  "LOW": "Bajo",
  "Represents the percentage of invested cash.":
    "Representa el porcentaje de dinero invertido.",
  "This section shows the sum of the net values of all investments, current balances and automatic applications.":
    "Esta sección presenta la suma de los valores netos de todas las inversiones, saldos disponibles en cuenta y aplicaciones automáticas.",
  "Represents the percentage of remuneration of fixed-income investments.":
    "Representa el porcentaje de remuneración de las inversiones de renta fija.",
  "This graph displays the invested cash position by type of investment.":
    "Esta gráfica muestra la posición de caja invertida por tipo de inversion.",
  "This graph displays investments to expire within a range of future dates.":
    "Esta gráfica muestra el vencimiento de inversiones en un intervalo de fechas futuras.",
  "This graph displays the daily evolution of credits and debits within a future date range.":
    "Esta gráfica muestra la evolución diaria de créditos y débitos en un intervalo de fechas futuro.",
  "Future Cash": "Caja futura",
  "Account status": "Estado de las cuentas",
  "This section presents the status of the accounts with respect to balances and automatic applications, compared to the established cash limits.":
    "Esta sección presenta el status de las cuentas respecto a los saldos y aplicaciones automáticas, en comparación con los limites de caja establecidos.",
  "Potential of gain in the remuneration account {{currency}} {{value}}":
    "Potencial de ganancia en la cuenta remunerada {{currency}} {{value}}",
  "Accounts ({{count}})": "Cuentas ({{count}})",
  "Enable recurrence": "Habilitar recurrencia",
  "We will send every {{periodDay}} at {{periodTime}}h.":
    "Enviaremos todos los {{periodDay}} a las {{periodTime}}h.",
  "{{periodDay}} at {{periodTime}}h.": "{{periodDay}} a las {{periodTime}}h.",
  "at {{periodTime}}h.": "a las {{periodTime}}h.",
  "MONDAY": "Lunes",
  "TUESDAY": "Martes",
  "WEDNESDAY": "Miércoles",
  "THURSDAY": "Jueves",
  "FRIDAY": "Viernes",
  "Weekly days": "Días semanales",
  "Best rescue option": "Mejor opción de rescate",
  "Exit fullscreen": "Salir de pantalla completa",
  "Fullscreen": "Pantalla completa",
  "Analytic": "Analítica",
  "UNCATEGORIZED": "Sin categoría",
  "TYPE_BATCH": "SISPAG",
  "TYPE_PIX": "PIX",
  "TYPE_TICKET": "BOLETO",
  "TYPE_SERVICE": "SERVICIO",
  "TYPE_TED": "TED",
  "TYPE_DOC": "DOC",
  "TYPE_OTHER": "OTRO",
  "Select view": "Seleccionar vista",
  "View list": "Lista de vistas",
  "The view will be created based on the previously applied filters.":
    "La vista se creará en función de los filtros aplicados anteriormente.",
  "New view": "Nueva vista",
  "Edit view": "Editar vista",
  "View management": "Gestión de vistas",
  "View successfully created!": "¡Vista creada exitosamente!",
  "View successfully edited!": "¡Vista editada exitosamente!",
  "View successfully saved!": "¡Vista guardada exitosamente!",
  "Are you sure you want to remove this View?":
    "¿Está seguro de que desea eliminar esta vista?",
  "View successfully deleted!": "¡Vista eliminada exitosamente!",
  "Consolidated view of balances": "Visión consolidada de saldos",
  "net surplus": "excedente neto",
  "Remaining balance to cover": "Saldo restante a cubrir",
  "{{count}} days_one": "{{count}} día",
  "{{count}} days_other": "{{count}} días",
  "New simulation": "Nueva simulación",
  "Simulation": "Simulación",
  "Investment simulation": "Simulación de inversión",
  "Calculate": "Calcular",
  "Perform new simulation": "Nueva simulación",
  "Value to be invested": "Valor a invertir",
  "Investment option": "Opción de inversión",
  "Above 30 days the best option would be CDB.":
    "Más de 30 días, la mejor opción sería CDB.",
  "For a term of less than 30 days, the best option is a Committed.":
    "Para un plazo inferior a 30 días, la mejor opción es una Compromisada.",
  "Remuneration (% of DI)": "Remuneración (% de DI)",
  "DI Rate (%)": "Tasa DI (%)",
  "IOF tax (%)": "Impuesto IOF (%)",
  "IR tax (%)": "Impuesto IR (%)",
  "Expected investment value": "Valor de la inversión prevista",
  "Term": "Plazo",
  "Potential financial gain (net)": "Ganancia financiera potencial (neta)",
  "DI Rate": "Tasa DI",
  "Gross gain": "Valor bruto",
  "IOF tax": "Imposto IOF",
  "IR tax": "Imposto IR",
  "Net gain": "Valor liquido",
  "Net profitability": "Rentabilidad liquida",
  "Deadline days": "Días de plazo",
  "Expiration date": "Fecha de Vencimiento",
  "Some links were not fully updated or they have not been updated since yesterday, affecting the information available on the platform. Please try to synchronize them again.":
    "Algunos enlaces no fueron actualizados de forma completa o no se actualizan desde ayer, afectando la informacion disponible en la plataforma. Por favor, intente sincronizarlas nuevamente.",
  "Synchronize now": "Sincronizar ahora",
  "Are you sure you want to synchronize them again?":
    "¿Estás seguro de que quieres sincronizarlos de nuevo?",
  "Transaction value": "Valor de la transacción",
  "Union": "Unión",
  "Intersection": "Intersección",
  "Double click to edit": "Doble click para editar",
  "Workspace user status": "Estado espacio de trabajo",
  "Total categories amount must match with":
    "El monto total de categorías debe coincidir con",
  "DEFAULT": "Defecto",
  "View": "Vista",
  "Views": "Vistas",
  "Payments to suppliers": "Pago a proveedores",
  "Optimization": "Optimización",
  "Cash flow evolution": "Evolución del flujo de caja",
  "Withdrawals": "Rescates",
  "Liquidity index": "Indicador de liquidez",
  "This graph shows how the cash flow evolves, separating the information between working capital and the evolution of investments and withdrawals. The Liquidity Index provides insight into the ability to meet short-term financial obligations and manage cash flow effectively.":
    "Este gráfico presenta como evoluciona el flujo de caja, separando la información entre working capital y la evolución de las inversiones y rescates. El Indicador de Liquidez proporciona información sobre la capacidad de cumplir con las obligaciones financieras a corto plazo y gestionar el flujo de caja de manera efectiva.",
  "Depending on the availability of the Banks, statements may be available up to the 5th business day.":
    "De acuerdo con la disponibilidad de los Bancos, los extractos podrán estar disponibles hasta el 5to día hábil.",
  "Download type": "Tipo de descarga",
  "FILE_LIST_DOWNLOAD_TYPE_DEFAULT": "Por defecto",
  "FILE_LIST_DOWNLOAD_TYPE_NONE": "Sin agrupar",
  "FILE_LIST_DOWNLOAD_TYPE_OWNER": "Agrupado por empresa",
  "Consolidated view by Owner": "Visión consolidada por Empresa",
  "Surplus balance": "Saldo excedente",
  "Balance to cover": "Saldo a cubrir",
  "Negative balance": "Saldo negativo",
  "Consolidated balance": "Saldo consolidado",
  "Consolidated value": "Valor consolidado",
  "Withdraw": "Rescatar",
  "View all applications": "Ver todas las aplicaciones",
  "Insufficient investment position to cover the accounts of this owner.":
    "Posición de inversión insuficiente para cubrir las cuentas de esta empresa.",
  "Transaction Type": "Tipo de transacción",
  "Add view": "Agregar vista",
  "Personalize the dashboard visualization, identify trends, and make strategic decisions based on accurate and up-to-date information.":
    "Personaliza la visualización del tablero, identifica tendencias y toma decisiones estratégicas basadas en información precisa y actualizada.",
  "Give a name to this visualization": "Da un nombre a esta vista",
  "Choose the criteria for visualization": "Elige los criterios para la vista",
  "The defined criteria will be the basis for the platform's visualization.":
    "Los criterios definidos serán la base para la vista de la plataforma.",
  "Choose the users who will have access to this visualization":
    "Elige los usuarios que tendrán acceso a esta vista",
  "The users will have \"Read-only\" permissions to access this visualization.":
    "Los usuarios tendrán permisos de \"Solo lectura\" para acceder a esta vista.",
  "You can create a custom criterias to sort the applications.":
    "Usted puede crear criterios personalizados para ordenar las aplicaciones.",
  "Portfolio performance": "Rendimiento del portfolio",
  "Loss": "Pérdida",
  "GENERAL_PORTFOLIO_PERFORMANCE_INFO_TEXT":
    "Este gráfico presenta la evolución mensual del rendimiento del portfolio de inversiones, en comparación con la tasa DI y la inflación de cada mes.",
  "Remember to configure the following email to send the statements to be processed automatically:":
    "Recuerde configurar el siguiente email para enviar los extractos y que sean procesados automáticamente:",
  "Enter the decryption key for the email.":
    "Introduzca la clave de descifrado del correo electrónico.",
  "You have \"Manual\" and/or \"Open Finance\" links that have not been updated yet. Please remember that they need to be updated manually.":
    "Posee enlaces de tipo \"Manual\" y/o \"Open Finance\" aún sin actualizar. Recuerde que deben ser actualizados manualmente.",
  "Additionally, please remember that the \"Manual\" and \"Open Finance\" links need to be updated manually.":
    "Adicionalmente, recuerde que los enlaces de tipo \"Manual\" y \"Open Finance\" que deben ser actualizados manualmente.",
  "Expiration detail": "Detalle del vencimiento",
  "External id": "Id externo",
  "My views": "Mis vistas",
  "Please note that the account list will be updated. This may involve adding new accounts and removing those that no longer exist in the Institution.":
    "Tenga en cuenta que el listado de cuentas se actualizará. Esto puede implicar que se agreguen nuevas cuentas y otras sean eliminadas dado que ya no existen en la Institución.",
  "Do you agree to continue?": "¿Desea continuar?",
  "Connecting Accounts": "Conectar cuentas",
  "Welcome to the new era of Intelligent Treasury":
    "Bienvenido a la nueva era de la <2>Tesorería Inteligente</2>",
  "Understand your company's cash flow and make strategic decisions.":
    "Entienda el flujo de caja de su empresa y tome decisiones estratégicas.",
  "Start now": "Comenzar ahora",
  "Defining Company Profile": "Definición del perfil de la empresa",
  "Cash Opening and Closing": "Apertura y cierre de caja",
  "This information will define the update time of links.":
    "Esta información definirá el tiempo de actualización de los enlaces.",
  "Choose the cash opening hours": "Elija el horario de apertura de caja",
  "hour": "hora",
  "Choose the cash closing time": "Elija la hora de cierre de caja",
  "Cash Management Limits and Goals": "Límites y meta de gestión de caja",
  "Minimum cash limit": "Límite de caja mínimo",
  "Maximum cash limit": "Límite de caja máximo",
  "Financial efficiency goal": "Meta de eficiencia",
  "Portfolio performance target": "Meta de desempeño de portfolio",
  "(fixed income)": "(renta fija)",
  "Let's start?": "¿Empezamos?",
  "To connect": "Conectar",
  "Attention": "Atención",
  "During the registration period of the links, we ask you not to access the internet banking until our dashboard is updated. This will ensure the safety and integrity of your information. Thank you for understanding!":
    "Durante el período de registro de los enlaces, le pedimos que no acceda a la banca de Internet hasta que se actualice nuestro tablero. Esto garantizará la seguridad y la integridad de su información. ¡Gracias por entender!",
  "Invite users to use the platform":
    "Invitar usuarios a utilizar la plataforma.",
  "Synchronizing": "Sincronizando",
  "Company settings successfully saved!":
    "Configuración de la empresa guardada con éxito!",
  "Efficiency Analysis: {{mondayLastWeek}} - {{fridayLastWeek}}":
    "<0>Análisis de eficiencia:</0> {{mondayLastWeek}} - {{fridayLastWeek}}",
  "Efficiency Analysis": "Análisis de eficiencia",
  "Period: {{mondayLastWeek}} - {{fridayLastWeek}}":
    "<0>Período:</0> {{mondayLastWeek}} - {{fridayLastWeek}}",
  "Period: {{dateFrom}} - {{dateTo}}":
    "<0>Período:</0> {{dateFrom}} - {{dateTo}}",
  "Scope: {{ totalCompleted }} owners analyzed (out of {{ total }})":
    "<0>Alcance:</0> {{ totalCompleted }} empresas analizadas (de un total de {{ total }})",
  "General efficiency": "Eficiencia general",
  "Daily average": "Promedio diario",
  "Indicates the overall efficiency of cash flow management during the analyzed week.":
    "Indica la eficiencia general de la gestión del flujo de caja durante la semana analizada.",
  "Liquidity indicator": "Indicador de liquidez",
  "Provides information on the ability to meet short-term financial obligations and manage cash flow effectively. It calculates the daily average of the comparison between the total credits and investment withdrawals with the total debits of each day.":
    "Proporciona información sobre la capacidad de cumplir con las obligaciones financieras a corto plazo y gestionar el flujo de caja de manera efectiva. Calcula el promedio diario de la comparación entre el total de créditos y rescates de inversiones con el total de débitos de cada día.",
  "Profit opportunity": "Oportunidad de mejora",
  "Additional liquid": "Líquido adicional",
  "It represents the opportunity to generate additional financial income as a result of the cash flow optimization opportunities detected by the Smart Cash Pilot.":
    "Representa la oportunidad de generar ingresos financieros adicionales como resultado de las oportunidades de optimización del flujo de caja detectadas por el Piloto de Caja Inteligente.",
  "Efficiency Planning": "Planificación de eficiencia",
  "This section presents the cash management for the analyzed week and compares it with the results of the Smart Cash Pilot management.":
    "Esta sección presenta la gestión de caja de la semana analizada y la compara con el resultado de la gestión del Piloto de Caja Inteligente.",
  "Model Optimization": "Piloto de Caja Inteligente",
  "Improvement opportunities": "Oportunidades de mejora",
  "Additional Gain Opportunities": "Oportunidades de ganancia adicionales",
  "Minimum Cash Analysis": "Análisis de caja mínimo",
  "Ok, continue": "Ok, continuar",
  "Categorize": "Categorizar",
  "Massive categorization": "Categorización masiva",
  "Transactions successfully saved!": "¡Transacciones guardadas con éxito!",
  "Pix successfully saved!": "Pix guardados con éxito!",
  "Payments successfully saved!": "Pagos guardados con éxito!",
  "Hello, {{name}}": "Hola, {{name}}",
  "Cash management": "Gestión de caja",
  "Banking institutions": "Instituciones bancarias",
  "{{name}}, what is your area and function in the company?":
    "{{name}}, ¿Cuál es su área y función en la empresa?",
  "Invitation sent": "Invitación enviada",
  "Area of action": "Área de acción",
  "Function / Position": "Función / posición",
  "Financial": "Financiera",
  "Treasury": "Tesorería",
  "Accounts payable": "Cuentas por pagar",
  "Accounts receivable": "Cuentas por cobrar",
  "Accounting": "Contabilidad",
  "FP&A": "FP&A",
  "Analyst": "Analista",
  "Coordinator": "Coordinador",
  "Manager": "Gerente",
  "Director": "Director",
  "Specialist": "Especialista",
  "Process": "Proceso",
  "Cash opening": "Apertura de caja",
  "Cash closing": "Cierre de caja",
  "Cash analysis frequency": "Frecuencia de análisis de caja",
  "Policies": "Políticas",
  "Liquidity": "Liquidez",
  "Products": "Productos",
  "Choose the day of the week": "Elija el día de la semana",
  "DDA": "Direito de Arena",
  "Analytical summary of the week: {{mondayLastWeek}} - {{fridayLastWeek}}":
    "<0>Resumen analítico de la semana:</0> {{mondayLastWeek}} - {{fridayLastWeek}}",
  "Analytical Summary": "Resumen Analítico",
  "Position Investments": "Posicionamiento de inversiones",
  "Financial movement": "Movimiento financiero",
  "You had {{count}} accounts with negative balance":
    "Tuviste <2>{{count}}</2> cuentas con saldo negativo",
  "Expected interest *:": "Interés esperado *",
  "Oldest application date": "Fecha de aplicación más antigua",
  "Incompleted sync": "Sincronización incompleta",
  "label.investmentsAppByMonthCustom": "Informe Ejecutivo",
  "Account from": "De",
  "Account to": "Para",
  "Day and hour": "Día y hora",
  "Created by": "Creado por",
  "Transfer created successfully!": "¡Transferencia creada con éxito!",
  "New transfer": "Nueva transferencia",
  "Search account": "Buscar cuenta",
  "Ok, close": "Ok, cerrar",
  "Transfers": "Transferencias",
  "TRANSFER_FAILED": "Fallida",
  "TRANSFER_REJECTED": "Rechazada",
  "TRANSFER_REQUESTED": "Solicitada",
  "TRANSFER_CONFIRMED": "Terminada",
  "TRANSFER_PENDING": "Pendiente",
  "TRANSFER_AWAITING_APPROVAL": "Esperando aprobación",
  "TRANSFER_APPROVED": "Aprobada",
  "TRANSFER_REPROVED": "Reprobada",
  "TRANSFER_REQUESTED_WITH_ERROR": "Con error",
  "TRANSFER_PENDING_CONFIRMATION": "Confirmación pendiente",
  "Transfer's detail": "Detalles de la transferencia",
  "Pix created successfully": "Pix creada con éxito",
  "Pix may take a few minutes to complete. Follow the status in the table below.":
    "Pix pueden tardar unos minutos en completarse. Siga el estado en la tabla a continuación.",
  "Confirm your pix transfer": "Confirme su transferencia de pix",
  "BLOCKED_JUDICIAL": "Saldo bloqueado judicialmente",
  "Registration status": "Estado de registro",
  "label.dailyBalancesByOwner": "Saldos diarios (por empresas)",
  "Pix key": "Llave pix",
  "key": "llave",
  "key type": "tipo de llave",
  "RANDOM": "Aleatoria",
  "PHONE": "Celular",
  "Calculates the average of the daily ratio that compares the total credits/withdrawals with the total debits/investments.":
    "Calcula el promedio del ratio diario que compara el total de créditos/rescates con el total de débitos/inversiones.",
  "30-day projection": "Proyectado a 30 días",
  "Investment order submitted": "Orden de inversión presentada",
  "The invested amount will be blocked until the process finishes.":
    "El monto invertido se bloqueará hasta que termine el proceso.",
  "In Analysis": "En análisis",
  "New investment": "Nueva inversión",
  "Confirm your investment": "Confirme su inversión",
  "Inlcude attachments": "Incluir archivos adjuntos",
  "Money movement": "Mover dinero",
  "Transfer": "Transferir",
  "Invest / Withdraw": "Invertir / Rescatar",
  "Manual transactions": "Transacciones manuales",
  "Manual transactions (Upload file)": "Transacciones manuales (Subir archivo)",
  "Manual positions": "Posiciones manuales",
  "Automatic application (balance)": "Aplicación Automática (saldo)",
  "Automatic application": "Aplicación Automática",
  "Committed (net value)": "Compromisada (valor neto)",
  "CDBs (net value)": "CDBs (valor neto)",
  "Funds (net value)": "Fondos (valor neto)",
  "Funds": "Fondos",
  "Total applied": "Total aplicado",
  "Values successfully saved!": "¡Valores guardados con correctamente!",
  "Check the details of your investments or make a withdrawal quickly and easily.":
    "Verifique los detalles de sus inversiones o realice un retiro de manera rápida y fácil.",
  "Investment history": "Histórico de inversiones",
  "New withdraw": "Nuevo rescate",
  "Net value available": "Valor líquido disponible",
  "Destination account": "Cuenta de destino",
  "Rescue details": "Detalles del rescate",
  "Withdrawal amount": "Monto a rescatar",
  "Confirm your withdraw": "Confirme su rescate",
  "Successful rescue order": "Orden de rescate exitosa",
  "FIXED_INCOME": "Renta fija",
  "Last Sync Time": "Última sincronización",
  "No previous updates": "No hay actualizaciones anteriores",
  "Investments - deposit": "Inversiones - Depósito",
  "Investments - committed": "Inversiones - Comprometida",
  "Investments - fund": "Inversiones - Fondo",
  "See totals": "Ver totales",
  "Click on bar to see details": "Haga clic en la barra para ver los detalles",
  "subCategory": "Sub categoría",
  "Sub category": "Sub categoría",
  "Which banks are included?": "¿Qué bancos están incluidos?",
  "Check out the table of available banks and extracts":
    "Consulte la tabla de bancos y extractos disponibles",
  "Checking account": "Cuenta corriente",
  "Transaction Categories Fees Per Month":
    "Tarifas de Categorías de Transacciones por Mes",
  "Projected annual": "Proyectado anual",
  "Annual goal": "Meta anual",
  "Cashflow manual entries": "Flujo de caja (Entradas manuales)",
  "Discard all changes": "Descartar todos los cambios",
  "Discard changes": "Descartar cambios",
  "Cashflow manual entries successfully saved!":
    "¡Entradas manuales de flujo de caja guardadas con éxito!",
  "Subcategory Type": "Tipo de Subcategoría",
  "Fixed Income Details": "Detalles de Renta Fija",
  "All year": "Todo el año",
  "Print": "Imprimir",
  "Working capital": "Capital de giro",
  "Analysis by Institution": "Análisis por institución",
  "Additional information": "Información adicional",
  "Average compensation CDI": "Remuneración media CDI",
  "Balance + Automatic Applications": "Saldo + Aplicaciones automáticas",
  "label.monthlyAnalyticalOverview": "Visión Analítica - Fotografía del Mes",
  "Enter your details to login.": "Ingrese sus datos para iniciar sesión.",
  "Please enter a valid email address":
    "Introduce un correo electrónico válido",
  "Create a new password": "Crear una nueva contraseña",
  "Set up a secure password to protect your account.":
    "Configure una contraseña segura para proteger su cuenta.",
  "Enter your details to active.": "Ingresa tus datos para activar.",
  "Accept the use": "Aceptar el uso",
  "Please enter a valid phone number": "Ingrese un número de teléfono válido",
  "Example": "Ejemplo",
  "Area activity": "Área de Actividad",
  "label.balancesModel": "Modelo de Balances",
  "Customer Reference": "Referencia del Cliente",
  "Overdraft limit check": "Límite cheque especial",
  "label.investmentsDailyPosition": "Posición Diaria de Inversiones",
  "label.dailyBalancesWithChart": "Saldos diarios con gráfico",
  "label.monthlyInvestmentPerformance": "Desempeño Mensual de Inversiones",
  "All applied rules reflect data from the last 7 days.":
    "Todas las reglas aplicadas reflejan datos de los últimos 7 días.",
  "Debts": "Deudas",
  "IOF Exempt Balance": "Saldo Líquido Libre de IOF",
  "Please review and accept to continue using our services.":
    "Revise y acepte para continuar utilizando nuestros servicios.",
  "User activated succefully!": "¡Usuario activado con éxito!",
  "Terms and Conditions accepted succefully!":
    "¡Términos y condiciones aceptados con éxito!",
  "label.dailyInvestmentPerformance": "Rentabilidad diario de inversiones",
  "Browse between categories": "Navega entre las categorías",
  "Follow your company's all financial position":
    "Siga la posición financiera de su empresa",
  "Follow the status of all your bank connections":
    "Siga el estado de todas sus conexiones bancarias",
  "Clear and up-to-date view of cash positions for strategic financial management":
    "Vista clara y actualizada de las posiciones de caja para la gestión financiera estratégica",
  "Follow your portfolio": "Siga su portfolio",
  "Follow your financial transactions": "Siga sus transacciones financieras",
  "Search client": "Buscar cliente",
  "Copy ID": "Copiar ID",
  "Loading information": "Cargando informaciones",
  "View investments": "Ver inversiones",
  "View cash pilot": "Ver piloto de caja",
  "Initiation type": "Tipo de iniciación",
  "label.pixTransactions": "Pix",
  "label.paymentsAndPixTransactions": "Pagos y Pix",
  "Regenerate Transaction Summary": "Regenerar Sumarización de Transacciones",
  "Display document": "Documento personalizado",
  "First quarter": "Primer cuarto",
  "Second quarter": "Segundo cuarto",
  "Third quarter": "Tercer cuarto",
  "Fourth quarter": "Cuarto cuarto",
  "Quarter": "Cuarto",
  "label.quarter01": "Optimización de caja",
  "label.quarter02": "Concentración bancaria",
  "label.quarter03": "Movimiento de caja",
  "label.datanomik": "Datanomik",
  "My extracts": "Mis extractos",
  "Extract status": "Estado",
  "Formats": "Formatos",
  "New extract": "Nuevo extracto",
  "Custom extracts may take up to 24 hours to process.":
    "Los extractos personalizados pueden tardar hasta 24 horas en procesarse.",
  "Add a description": "Agregar una descripción",
  "Choose a link": "Elija un enlace",
  "Status of available extracts": "Estado de los extractos disponibles",
  "Status of available downloads": "Estado de las descargas disponibles",
  "Extracts": "Extracts",
  "Download available": "Download available",
  "Last 7 Days": "Últimos 7 días",
  "Last 30 Days": "Últimos 30 días",
  "Current Month": "Mes actual",
  "Prev Month": "Mes previo",
  "The initial date is required": "La fecha inicial es requerida",
  "The final date is required": "La fecha final es requerida",
  "Download completed successfully!": "¡Descarga completada con éxito!",
  "Period statement execution created succefully!":
    "Ejecución de extracto por período creada con éxito!",
  "label.periodStatementExecutions": "Ejecuciones de extracto por período",
  "Period statement executions": "Ejecuciones de extracto por período",
  "Payment": "Pago",
  "Edit payment categories": "Editar categorías de pago",
  "Edit pix categories": "Editar categorías de pix",
  "Overdraft": "Sobregiro",
  "Recategorize Transactions": "Recategorizar Transacciones",
  "Categorization types": "Tipos de categorización",
  "In progress extracts": "En progreso y pendintes:",
  "Failed extracts": "Fallados:",
  "Completed extracts": "Obtenidos:",
  "In progress statement process": "Proceso de obtencion en progreso:",
  "Pending statement process": "Proceso de obtencion pendiente:",
  "Completed statement process": "Proceso de obtencion completado:",
  "Executions": "Ejecuciones",
  "Download status": "Estado de descarga",
  "My reports": "Mis reportes",
  "CUSTOM": "Personalizada",
  "Types of investments": "Tipos de inversiones",
  "Check out all types of investments in your portfolio":
    "Consulta todos los tipos de inversiones en tu portafolio",
  "Gross profitability": "Rentabilidad bruta",
  "Details": "Detalles",
  "Total balance": "Saldo total",
  "Close to maturity": "Próximo al vencimiento",
  "Distribution by liquidity": "Distribución por liquidez",
  "Investments by institutions": "Inversiones por instituciones",
  "Evolution of total investment": "Evolución de la inversión total",
  "Day": "Día",
  "Week": "Semana",
  "Total investment": "Inversión total",
  "Gross profit.": "Rent. bruta",
  "Net profit.": "Rent. neta",
  "Performance CDI": "Rendimiento CDI",
  "Gross accumulated profitability": "Rentabilidad acumulada bruta",
  "Month movements": "Movimientos del mes",
  "movementInflow": "Ingreso",
  "movementOutflow": "Retiro",
  "Commercial dollar": "Dólar comercial",
  "Clone view": "Clonar vista",
  "Fixed income investment": "Inversión de renta fija",
  "Committed investment": "Inversión comprometida",
  "Fund investment": "Fondos de inversión",
  "COE investment": "Inversión de COE",
  "Gross yield": "Rendimiento bruto",
  "Total Last month": "Acumulado mes anterior",
  "Accumulated": "Acumulado mes actual",
  "CDBs deadlines": "Plazos de CDBs",
  "Committed deadlines": "Plazos de comprometidas",
  "Diversification of fixed income": "Diversificación de renta fija",
  "Diversification of committed": "Diversificación de comprometidas",
  "Diversification of investment funds":
    "Diversificación de fondos de inversión",
  "Total gross expiration": "Total bruto por vencimiento",
  "Types present in the wallet": "Tipos presentes en la cartera",
  "Funds present in the wallet": "Fondos presentes en la cartera",
  "Generate Monthly": "Generar extractos bancarios mensuales",
  "Committed days": "Días comprometidas",
  "Unsaved changes": "Cambios sin guardar",
  "You have unsaved changes. Do you want to save them before closing?":
    "¿Tienes cambios sin guardar. ¿Quieres guardarlos antes de cerrar?",
  "Position of applications": "Posición de las aplicaciones",
  "Application": "Aplicación",
  "Allocation": "Asignación",
  "Purchase date": "Fecha de compra",
  "Maturity": "Vencimiento",
  "# note": "# nota",
  "Purchase rate": "Tasa de compra",
  "All institutions": "Todas las instituciones",
  "All owners": "Todas las empresas",
  "Net amount": "Saldo líquido",
  "Total net": "Total líquido",
  "Set the minimum CDI percentage expected by type of investment and the ideal maximum deadline for committed.":
    "Establezca el porcentaje mínimo de CDI esperado por tipo de inversión y el plazo máximo ideal para comprometidas.",
  "Maximum period in Committed": "Período máximo en Comprometidas",
  "applied days": "días aplicados",
  "Applications CDB": "Aplicaciones CDB",
  "Applications Committed": "Aplicaciones Comprometidas",
  "Applications Funds": "Fondos",
  "Applications COE": "Aplicaciones de COE",
  "Application details": "Detalles de la aplicación",
  "Over {{days}} days applied": "Encima de {{days}} días aplicados",
  "CDI is below {{cdi}}%": "CDI está debajo {{cdi}}%",
  "Set minimum and/or maximum cash limits for the selected accounts":
    "Establezca límites de caja mínimos y/o máximos para las cuentas seleccionadas",
  "No application with maturity for today.":
    "No hay aplicación con vencimiento para hoy.",
  "No application with maturity.": "No hay aplicación con vencimiento.",
  "Next maturity": "Próximo vencimiento",
  "{{total}} applications": "{{total}} aplicaciones",
  "1 application": "1 aplicación",
  "No application with low performance":
    "No hay aplicación con bajo rendimiento",
  "Learn more in settings": "Obtenga más información en configuración",
  "Payment controller": "Controlador de pago",
  "PAYMENT_CONTROLLER": "Controlador de pago",
  "XP_OF": "XP",
  "CAIXA": "Caixa",
  "BRADESCO_OF": "Bradesco",
  "ITAU_OF": "Itaú",
  "SANTANDER_OF": "Santander",
  "BV_OF": "BV",
  "BTG_PACTUAL_CORP": "BTG",
  "CAIXA_READONLY": "Caixa",
  "UNICRED_OF": "Unicred",
  "BANCO_BRASIL_OF": "Banco do Brasil",
  "NORDESTE": "Nordeste",
  "SOFISA": "Sofisa",
  "STARK_BANK": "Stark Bank",
  "AGORA_OF": "Agora",
  "BTG_EMPRESAS_OF": "BTG",
  "SICREDI": "Sicredi",
  "AGORAINVESTIMENTOS": "Agora Investimentos",
  "XP": "XP",
  "SOFISA_OF": "Sofisa",
  "SAFRA": "Safra",
  "ITAU_WEB": "Itaú",
  "BANRISUL": "Banrisul",
  "ABC": "ABC",
  "BANCO_RENDIMENTO_OF": "Banco Rendimento",
  "C6_OF": "C6",
  "PINE": "Pine",
  "BTG_INVESTMENT_OF": "BTG",
  "CAIXA_OF": "Caixa",
  "SICOOB": "Sicoob",
  "SANTANDER": "Santander",
  "BRADESCO": "Bradesco",
  "label.allInstrumentMovements":
    "Movimiento de inversión: todos los instrumentos",
  "Some of the selected payments are older than 3 months and will not be requested.":
    "Algunos de los pagos seleccionados tienen más de 3 meses y no se solicitarán.",
  "Owners and Accounts": "Empresas y Cuentas",
  "You are in the default view. Deleting this category here will permanently remove it from the entire system, including all other views.":
    "Estás en la vista predeterminada. Eliminar esta categoría aquí la eliminará permanentemente de todo el sistema, incluidas todas las demás vistas.",
  "Type the name of the category to confirm deletion:":
    "Escribe el nombre de la categoría para confirmar la eliminación:",
  "Are you sure you want to delete this category group?":
    "¿Estás seguro de que deseas eliminar este grupo de categorías? Todas las categorías asociadas a este grupo se moverán al grupo \"Otros\".",
  "label.investmentsPortfolio": "Portfolio de inversiones",
  "Investments Portfolio.": "Portfolio de inversiones.",
  "Statement format": "Formato de estado",
  "Choose statement format": "Elegir formato de estado",
  "Only PDF": "Solo PDF",
  "Only OFX": "Solo OFX",
  "Only XLS": "Solo XLS",
  "PDF and OFX": "PDF y OFX",
  "Conciliator ID": "ID del Conciliador",
  "Datetime": "Fecha y hora",
  "Total investment performance": "Rendimiento total de inversión",
  "Monthly performance comparison": "Comparación de rendimiento mensual",
  "Liquid profitability": "Rentabilidad líquida",
  "CDI average": "Promedio de CDI",
  "IOF incident": "IOF incidente",
  "IOF average": "Promedio de IOF",
  "IR average": "Promedio de IR",
  "Rescue index": "Índice de rescate",
  "Asset performance": "Rendimiento de activos",
  "Days average": "Promedio de días",
  "Support": "Soporte",
  "Your Manager": "Tu Gerente",
  "General Support": "Soporte General",
  "Report a problem": "Reportar un problema",
  "Open a ticket for the technical team":
    "Abrir un ticket para el equipo técnico",
  "Report.action": "Reportar",
  "Documentation": "Documentación",
  "Check out how to integrate our APIs": "Mira cómo integrar nuestras APIs",
  "Open": "Abrir",
  "Suggestions & Improvements": "Sugerencias y Mejoras",
  "Send us your idea": "Envíanos tu idea",
  "Suggest": "Sugerir",
  "We want to hear from you": "Queremos saber de ti",
  "ZenDesk": "ZenDesk",
  "Create and manage your tickets": "Crea y gestiona tus tickets",
  "Talk to support": "Hablar con Soporte",
  "Open In Web": "Abrir en la Web",
  "Support Hours": "Atención",
  "Monday to Friday from 9am to 6pm.": "Lunes a Viernes de 9 a 18 hs.",
  "Scan the QR Code with your phone": "Escanea el código QR con tu celular",
  "Describe your idea": "Describe tu idea",
  "Type your suggestion here...": "Escribe tu sugerencia aquí...",
  "This field is required": "Este campo es obligatorio",
  "The suggestion must be at least 10 characters long":
    "La sugerencia debe tener al menos 10 caracteres",
  "Send": "Enviar",
  "label.dailyConciliation": "Conciliación diaria",
  "Thank you for your suggestion!": "¡Gracias por tu sugerencia!",
  "Your feedback helps us improve our service.":
    "Tus comentarios nos ayudan a mejorar nuestro servicio.",
  "ITAU_BBA": "Itaú BBA",
  "MERCURY": "Mercury",
  "JEEVES": "Jeeves",
  "BREX": "Brex",
  "SVB": "Silicon Valley",
  "MORGAN_STANLEY": "Morgan Stanley",
  "SILICON_VALLEY": "Silicon Valley",
  "Validating login to {{institution}}":
    "Validando el inicio de sesión en {{institution}}",
  "See less": "Ver menos",
  "more": "más",
  "Projected percentage": "Porcentaje proyectado",
  "label.dailyCashStatement": "Relación de caja diaria",
  "label.accountsBalanceErp": "Balance de cuentas - ERP",
  "Profitability and gain month by month": "Rentabilidad y ganancia mes a mes",
  "Monthly asset evolution": "Evolución del activo mensual",
  "Average annual CDI Performance": "Rendimiento promedio anual CDI",
  "Annual profitability": "Rentabilidad anual",
  "Investment comparator": "Comparador de inversiones",
  "Deadline for rescue": "Plazo para rescate",
  "Enter a value": "Ingrese un valor",
  "Use idle balance": "Usar saldo ocioso",
  "Investment Performance Analysis": "Análisis de Performance de Inversiones",
  "DI return": "Remuneración DI",
  "Due date": "Fecha de vencimiento",
  "Equilibrium": "Punto de equilibrio",
  "Follow all about your investments": "Sigue todo sobre tus inversiones",
  "Bank Credentials": "Credenciales bancarias",
  "Your credentials are encrypted and stored securely.":
    "Tus credenciales son encriptadas y almacenadas de forma segura.",
  "Secure integration with your bank.": "Integración segura con tu banco.",
  "To automate your transactions and connect your bank account to the platform, please enter the credentials provided by your bank.":
    "Para automatizar tus transacciones y conectar tu cuenta bancaria a la plataforma, por favor ingresa las credenciales proporcionadas por tu banco.",
  "New Credential": "Nueva Credencial",
  "Connect your bank credentials securely.":
    "Conecta tus credenciales bancarias de forma segura.",
  "To carry out transactions automatically, we need you to enter the credentials provided by your bank. This information is used only to integrate your bank account and is not exposed at any time.":
    "Para realizar transacciones automáticamente, necesitamos que ingreses las credenciales proporcionadas por tu banco. Esta información se utiliza únicamente para integrar tu cuenta bancaria y no se expone en ningún momento.",
  "No credentials registered for this bank":
    "No hay credenciales registradas para este banco",
  "1 credential registered for this bank":
    "<b>1 credencial</b> registrada para este banco",
  "{{count}} credentials registered for this bank":
    "<b>{{count}} credenciales</b> registradas para este banco",
  "Public Certificate": "Certificado público",
  "Private Certificate": "Certificado privado",
  "Client Secret": "Secreto del cliente",
  "Client ID": "ID de cliente",
  "Api Key": "Clave de API",
  "Create Credential": "Crear Credencial",
  "Could not validate the data. Please confirm and try again.":
    "No se pudieron validar los datos. Por favor, confirma e intenta de nuevo.",
  "Change": "Cambiar",
  "Integrations": "Integraciones",
  "Certificate": "Certificado",
  "Certificates": "Certificados",
  "Certificate found": "Certificado encontrado",
  "A1 Certificate": "Certificado A1",
  "Replace Certificate": "Reemplazar Certificado",
  "label.financialEfficiency": "Eficiencia Financiera",
  "Institution Client Id": "ID de cliente",
  "Choose an institution": "Elige una institución",
  "Remuneration Account": "Cuenta de Remuneración",
  "label.applicationHistory": "Histórico de aplicaciones",
  "Rejection reason": "Razón de rechazo",
  "Barcode": "Código de barras",
  "Change to view mode": "Cambiar a modo de vista",
  "Change to edit mode": "Cambiar a modo de edición",
  "Cashflow projected successfully saved!":
    "Flujo de caja proyectado guardado con éxito!",
  "Manual cash flow (Upload file)": "Flujo de caja manual (Subir archivo)",
  "label.futureTransactions": "Transacciones futuras",
  "Edit purchase rate": "Editar tasa de compra",
  "Purchase rate updated successfully": "Tasa de compra actualizada con éxito",
  "Go to Datanomik Treasury": "Ir a Datanomik Treasury",
  "View transfer rules": "Ver reglas de transferencia",
  "Transfer rules for remuneration account":
    "Reglas de transferencia para cuenta remunerada",
  "Rule": "Regla",
  "Amount to transfer": "Valor a transferir",
  "Fixed amount": "Valor fijo",
  "Above amount": "Superior a {{amount}}",
  "Excess amount": "Valor excedente",
  "Accounts without statement": "Cuentas sin extracto",
  "Without statement detail": "Detalle sin extracto",
  "With receipt": "Con comprobante",
  "1 receipt requested": "1 comprobante solicitado",
  "{{count}} receipts requested": "{{count}} comprobantes solicitados",
  "Showing requested receipts": "Mostrando comprobantes solicitados",
  "label.paymentSlips": "Boletos de pago",
  "Payment slips by account.": "Boletos de pago por cuenta.",
  "Payment slip": "Boleto de pago",
  "PAYMENT_SLIP": "Boleto de pago",
  "Select or drop PFX file": "Seleccione o arrastre el archivo PFX",
  "PFX Password": "Contraseña del PFX",
  "Validate": "Validar",
  "Invalid PFX file": "Archivo PFX inválido",
  "Invalid password": "Contraseña inválida",
  "Download all filtered payment receipts":
    "Descargar todos los recibos de pago filtrados",
  "Request all filtered payment receipts":
    "Solicitar todos los recibos de pago filtrados",
  "Cannot download more than 1000 payments receipts.":
    "No se pueden descargar más de 1000 comprobantes.",
  "NEXT_DAY": "Próximo día",
  "NEXT_WEEK": "Próxima semana",
  "NEXT_15_DAYS": "Próximos 15 días",
  "NEXT_30_DAYS": "Próximos 30 días",
  "NEXT_MONTH": "Próximo mes",
  "DERIVATIVE": "Derivado",
  "Derivative investment": "Inversión derivada",
  "BANK_OF_CHINA": "Bank of China",
  "label.bankTransfersErp": "Movimiento de Aplicaciones",
  "Our number": "Nuestro número",
  "Your number": "Su número",
  "Payer": "Pagador",
  "Charged amount": "Valor cobrado",
  "Fluctuation": "Fluctuación",
  "Occurrence": "Ocurrencia",
  "Datanomik Certificate": "Certificado Datanomik",
  "Datanomik is a partner of this institution, therefore you do not need to upload a certificate":
    "Datanomik es un socio de esta institución, por lo tanto, no necesitas subir un certificado",
  "Datanomik Partner": "Socio Datanomik",
  "Invalid MFA code": "Código MFA inválido",
  "Realized": "Realizado",
  "Categories breakdown": "Desglose por categorías",
  "Projected balance": "Saldo proyectado",
  "vs projected": "vs proyectado",
  "No data available for this date": "No hay datos disponibles para esta fecha",
  "Click on a bar to see category breakdown":
    "Haga clic en una barra para ver el desglose",
  "No data available": "No hay datos disponibles",
  "Press ESC to exit": "Presione ESC para salir",
  "Realized Inflows": "Créditos realizados",
  "Projected Inflows": "Créditos proyectados",
  "Realized Outflows": "Débitos realizados",
  "Projected Outflows": "Débitos proyectados",
  "Net Cash Flow": "Flujo de caja neto",
  "Sections breakdown": "Desglose por secciones",
  "Click on a section to see its categories":
    "Haga clic en una sección para ver sus categorías",
  "label.unifiedInflowTransactions": "Transacciones de Ingreso Unificadas",
  "label.cashPoolingAccounts": "Cuentas - Flujo de Caja",
  "Cash pooling account balances.":
    "Saldo de cuentas para flujo de caja con proyección de cuenta remunerada",
  "Transfer Client Id": "Id del cliente para transferencia",
  "Transfer Client Secret": "Contaseña deñ cliente para transferencia",
  "Pix Transfer Client Id": "Id del cliente para transferencia PIX",
  "Pix Transfer Client Secret": "Contaseña del cliente para transferencia PIX",
  "Client Id": "Id de cliente",
  "label.financialPlanning": "Planeamiento financiero",
  "label.consolidatedInvestmentsApplication": "Informe consolidado de inversiones - Rentabilidad",
  "cashPooling.downloadReport": "Descargar reporte",
  "cashPooling.downloadReport.excel": "Excel",
  "cashPooling.downloadReport.pdf": "PDF",
  "cashPooling.downloadReport.processing": "Generando el reporte, puede seguir navegando...",
  "cashPooling.downloadReport.success": "Reporte descargado con éxito.",
  "cashPooling.downloadReport.error": "No fue posible descargar el reporte. Intente nuevamente.",
  "cashPooling.downloadReport.errorTitle": "Error al descargar",

  "Section successfully created!": "¡Sección creada con éxito!",
  "Section successfully saved!": "¡Sección guardada con éxito!",
  "Section successfully deleted!": "¡Sección eliminada con éxito!",
  "Edit Section": "Editar Sección",
  "New Section": "Nueva Sección",
  "Are you sure you want to remove this Section?": "¿Está seguro de que desea eliminar esta Sección?",
  "Category groups": "Grupos de categorías",
  "{{count}} selected": "{{count}} seleccionado(s)",
  "All groups are assigned": "Todos los grupos están asignados",
  "Click to select · Drag to assign": "Clic para seleccionar · Arrastre para asignar",
  "No groups assigned": "Sin grupos asignados",
  "Drop here to assign": "Suelte aquí para asignar",
  "Create a section using the form above": "Cree una sección usando el formulario de arriba",
  "1 category": "1 categoría",
  "{{count}} categories": "{{count}} categorías",
  "Hide categories": "Ocultar categorías",
  "Show categories": "Mostrar categorías",
  "Remove from section": "Quitar de la sección",
  "groups": "grupos",
  "categories": "categorías",
  "Links e Contas": "Links y Cuentas",
  "Contas": "Cuentas",
  "Posição de Caixa": "Posición de Caja",
  "Evolução de Saldo": "Evolución de Saldo",
  "Posições Manuais": "Posiciones Manuales",
  "Movimentos": "Movimientos",
  "Performance": "Rendimiento",
  "Fluxo de Caixa": "Flujo de Caja",
  "Configurações": "Configuración",
  "Extratos e Fechamento": "Extractos y Cierre",
  "Fechamento Financeiro": "Cierre Financiero",
  "Extratos Bancários": "Extractos Bancarios",
  "Regras automáticas": "Reglas automáticas",
  "Nova transferência": "Nueva transferencia",
  "Visão Geral": "Visión General",
  "Dívidas": "Deudas",
  "Nova dívida": "Nueva deuda",
  "Origin Account": "Cuenta de Origen",
  "Destination Account": "Cuenta de Destino",
  "Mode": "Modo",
  "Select the transfer mode": "Seleccione el modo de transferencia",
  "Transfer Type": "Tipo de Transferencia",
  "Amount": "Valor",
  "Amount to transfer": "Valor a transferir",
  "optional": "opcional",
  "Description": "Descripción",
  "Add a description...": "Agregue una descripción...",
  "Continue": "Continuar",
  "Transfer amount": "Valor de la transferencia",
  "Origin": "Origen",
  "Destination": "Destino",
  "Protected and audited transfer": "Transferencia protegida y auditada",
  "Back": "Volver",
  "Confirm": "Confirmar",
  "Transfer": "Transferir",
  "Fill in the details": "Complete los detalles",
  "Confirm transfer": "Confirmar transferencia",
  "Review the data before confirming": "Revise los datos antes de confirmar",
  "Processing transfer": "Procesando transferencia",
  "Please wait...": "Aguarde un momento...",
  "Transfer completed": "Transferencia completada",
  "Successfully processed": "Procesada con éxito",
  "Transfer failed": "Transferencia fallida",
  "Could not process": "No fue posible procesar",
  "Validating": "Validando",
  "Authorizing": "Autorizando",
  "Sending": "Enviando",
  "Processing transfer...": "Procesando transferencia...",
  "Sent to": "Enviado a",
  "Destination account": "Cuenta destino",
  "Date & time": "Fecha y hora",
  "Close": "Cerrar",
  "New transfer": "Nueva transferencia",
  "Transaction error": "Error en la transacción",
  "An error occurred while processing the transfer. Check the data and available balance in the origin account.": "Ocurrió un error al procesar la transferencia. Verifique los datos y el saldo disponible en la cuenta de origen.",
  "Try again": "Intentar nuevamente",
  "Create rule": "Crear regla",
  "Create credentials": "Crear credenciales",
  "Overview": "Visión General",
  "Rules": "Reglas",
  "The Cash Pooling module is paused": "El módulo Cash Pooling está pausado",
  "Enable it in Cash Pooling Settings": "Actívelo en Configuraciones de Cash Pooling",
  "Day & time": "Día y hora",
  "From": "De",
  "To": "Para",
  "Automatic": "Automático",
  "Manual": "Manual",
  "Latest transactions": "Últimas transacciones",
  "{{count}} transfer executed today": "{{count}} transferencia(s) ejecutada(s) hoy",
  "View all": "Ver todas",
  "No recent transactions.": "No hay transacciones recientes.",
  "Latest transfers": "Últimas transferencias",
  "No recent transfers": "No hay transferencias recientes",
  "Rule": "Regla",
  "Branch": "Agencia",
  "Company": "Empresa",
  "Excess balance": "Saldo excedente",
  "Minimum cash": "Caja mínimo",
  "Recurrence": "Recurrencia",
  "{{count}} active": "{{count}} activa(s)",
  "No companies found.": "No se encontraron empresas.",
  "Rows per page:": "Filas por página:",
  "of": "de",
  "Rules for automatic transfers": "Reglas para transferencias automáticas",
  "Error loading companies: {{message}}": "Error al cargar empresas: {{message}}",
  "No companies found with the applied filters.": "No se encontraron empresas con los filtros aplicados.",
  "CNPJ or Name": "CNPJ o Nombre",
  "Transfer details": "Detalles de la transferencia",
  "Sent via Pix API": "Enviado vía API Pix",
  "Sent via Bank Transfer": "Enviado vía Transferencia Bancaria",
  "Sent": "Enviado",
  "Failed": "Falló",
  "DETAILS": "DETALLES",
  "Cash Pooling": "Cash Pooling",
  "Date": "Fecha",
  "FROM:": "DE:",
  "TO:": "PARA:",
  "CNPJ": "CNPJ",
  "Bank": "Banco",
  "Checking account": "Cuenta corriente",
  "Rule created by": "Regla creada por",
  "Add New Rule": "Agregar Nueva Regla",
  "No rules created": "No hay reglas creadas",
  "{{count}} paused": "{{count}} pausada(s)",
  "Rules of {{ownerName}}": "Reglas de {{ownerName}}",
  "Delete rule": "Eliminar regla",
  "Are you sure you want to delete this rule? This action cannot be undone.": "¿Está seguro que desea eliminar esta regla? Esta acción no se puede deshacer.",
  "Cancel": "Cancelar",
  "Deleting...": "Eliminando...",
  "Delete": "Eliminar",
  "The rule was successfully deleted.": "La regla fue eliminada exitosamente.",
  "Rule deleted": "Regla eliminada",
  "Could not delete the rule. Please try again.": "No fue posible eliminar la regla. Intente nuevamente.",
  "Error deleting": "Error al eliminar",
  "The rule was successfully executed.": "La regla fue ejecutada exitosamente.",
  "Rule executed": "Regla ejecutada",
  "Could not execute the rule. Please try again.": "No fue posible ejecutar la regla. Intente nuevamente.",
  "Error executing": "Error al ejecutar",
  "The rule status was successfully updated.": "El estado de la regla fue actualizado exitosamente.",
  "Status updated": "Estado actualizado",
  "Could not update the rule status. Please try again.": "No fue posible actualizar el estado de la regla. Intente nuevamente.",
  "Error updating": "Error al actualizar",
  "All rules": "Todas las reglas",
  "Add rule": "Agregar regla",
  "Rule enabled": "Regla activada",
  "Rule disabled": "Regla desactivada",
  "More actions": "Más acciones",
  "actions menu": "menú de acciones",
  "Execute now": "Ejecutar ahora",
  "Execution history": "Historial de ejecuciones",
  "Edit": "Editar",
  "the excess over": "el exceso sobre",
  "the necessary to cover": "lo necesario para cubrir",
  "the amount of": "el valor de",
  "send to": "envían a",
  "sends to": "envía a",
  "Monday": "Lunes",
  "Tuesday": "Martes",
  "Wednesday": "Miércoles",
  "Thursday": "Jueves",
  "Friday": "Viernes",
  "Saturday": "Sábado",
  "Sunday": "Domingo",
  "Every day": "Todos los días",
  "Last execution:": "Última ejecución:",
  "Next execution:": "Próx. ejecución:",
  "Create the first rule for": "Cree la primera regla para",
  "accounts": "cuentas",
  "Invalid rule type. Please select a valid rule type.": "Tipo de regla inválido. Seleccione un tipo de regla válido.",
  "Create Rule": "Crear Regla",
  "Rule Creation": "Creación de Regla",
  "Select the balance rule type": "Seleccione el tipo de regla de saldo",
  "Automate transfers based on your account balance.": "Automatice transferencias basadas en el saldo de su cuenta.",
  "If the account(s)": "Si la(s) cuenta(s)",
  "Is (are) above": "Está(n) por encima de",
  "Amount to keep in account": "Valor a mantener en la cuenta",
  "Transfer to": "Transferir a",
  "Saving...": "Guardando...",
  "Save Changes": "Guardar Cambios",
  "Creating...": "Creando...",
  "If the account": "Si la cuenta",
  "Is below": "Está por debajo de",
  "Minimum amount required in account": "Valor mínimo necesario en la cuenta",
  "Receive from": "Recibir de",
  "Fixed amount to transfer": "Valor fijo a transferir",
  "Frequency": "Frecuencia",
  "Specific days of the week": "Días específicos de la semana",
  "at": "a las",
  "Select at least one day of the week": "Seleccione al menos un día de la semana",
  "Add a description for this rule...": "Agregue una descripción para esta regla...",
  "Mon": "Lun",
  "Tue": "Mar",
  "Wed": "Mié",
  "Thu": "Jue",
  "Fri": "Vie",
  "Cash Pooling Settings": "Configuraciones de Cash Pooling",
  "Cash Pooling Status:": "Estado del Cash Pooling:",
  "Active": "Activo",
  "Rules will respect their current state.": "Las reglas respetarán su estado actual.",
  "Rules will be disabled, regardless of their current state.": "Las reglas serán desactivadas, independientemente de su estado actual.",
  "Cash pooling with treasury intelligence.": "Cash pooling con inteligencia de tesorería.",
  "Create automatic rules for moving funds between accounts and maintain the ideal balance at each institution.": "Cree reglas automáticas de movimiento entre cuentas y mantenga el saldo ideal en cada institución.",
  "Export report": "Exportar informe",
  "Transfer history": "Historial de transferencias",
  "Rule not found. Please go back and try again.": "Regla no encontrada. Vuelva e intente nuevamente.",
  "Invalid rule type. Please go back and try again.": "Tipo de regla inválido. Vuelva e intente nuevamente.",
  "Edit Rule": "Editar Regla",
  "records": "registros",
  "CNPJ / Company": "CNPJ / Empresa",
  "Select...": "Seleccione...",
  "CNPJ not found": "CNPJ no encontrado",
  "Account": "Cuenta",
  "No projections found.": "No se encontraron proyecciones.",
  "View": "Ver",
  "Projections": "Proyecciones",
  "Add row": "Agregar fila",
  "Loading projections...": "Cargando proyecciones...",
  "Select an account": "Seleccione una cuenta",
  "No projections for this date": "No hay proyecciones para esta fecha",
  "Add rows manually, upload a file, or drag an Excel/CSV to this area": "Agregue filas manualmente, suba un archivo o arrastre un Excel/CSV a esta área",
  "Add manually": "Agregar manualmente",
  "Uploading...": "Subiendo...",
  "Upload file": "Subir archivo",
  "Processing...": "Procesando...",
  "item": "ítem",
  "items": "ítems",
  "Processing failed": "Falló el procesamiento",
  "Unsupported file": "Archivo no soportado",
  "Uploaded by": "Subido por",
  "on": "el",
  "Projected Payment": "Pago Proyectado",
  "No file uploaded": "Ningún archivo subido",
  "View details": "Ver detalles",
  "File uploaded successfully!": "¡Archivo subido exitosamente!",
  "Upload complete": "Subida completa",
  "Error uploading file. Please try again.": "Error al subir el archivo. Intente nuevamente.",
  "Upload error": "Error de subida",
  "Please select a valid file (Excel or CSV)": "Seleccione un archivo válido (Excel o CSV)",
  "Uploading file...": "Subiendo archivo...",
  "File loaded successfully": "Archivo cargado exitosamente",
  "Select the type of rule you want to create": "Seleccione el tipo de regla que desea crear",
  "Create New Rule": "Crear Nueva Regla",
  "The intelligent way to transfer resources.": "La forma inteligente de transferir recursos.",
  "Minimum Balance Rule": "Regla de Caja mínimo",
  "Excess Balance Rule": "Regla de Saldo Excedente",
  "Fixed Amount Rule": "Regla de Valor fijo",
  "Credentials": "Credenciales",
  "Paused": "Pausado",
};
